import { a7 as un, a as ee } from "./auth-B0ZSQBHe.js";
import { ref as Je, markRaw as be } from "vue";
function pn(e, n) {
  for (var l = 0; l < n.length; l++) {
    const i = n[l];
    if (typeof i != "string" && !Array.isArray(i)) {
      for (const a in i)
        if (a !== "default" && !(a in e)) {
          const t = Object.getOwnPropertyDescriptor(i, a);
          t && Object.defineProperty(e, a, t.get ? t : {
            enumerable: !0,
            get: () => i[a]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
var dn = /* @__PURE__ */ ((e) => (e.And = "AND", e.Or = "OR", e))(dn || {}), X = /* @__PURE__ */ ((e) => (e.Between = "BETWEEN", e.Eq = "EQ", e.Gt = "GT", e.Gte = "GTE", e.In = "IN", e.ILike = "I_LIKE", e.Like = "LIKE", e.Lt = "LT", e.Lte = "LTE", e.NotBetween = "NOT_BETWEEN", e.NotIn = "NOT_IN", e.NotILike = "NOT_I_LIKE", e.NotLike = "NOT_LIKE", e.NEq = "N_EQ", e))(X || {}), rn = /* @__PURE__ */ ((e) => (e.Asc = "ASC", e.Desc = "DESC", e))(rn || {}), cn = /* @__PURE__ */ ((e) => (e.Status = "Status", e.Volume = "Volume", e))(cn || {});
const c = X, Ol = {
  ID: [c.Eq, c.NEq, c.In, c.NotIn],
  String: [c.Eq, c.NEq, c.Like, c.ILike, c.NotLike, c.NotILike, c.In, c.NotIn],
  Boolean: [c.Eq, c.NEq],
  Int: [c.Eq, c.NEq, c.Gt, c.Gte, c.Lt, c.Lte, c.Between, c.NotBetween, c.In, c.NotIn],
  Float: [c.Eq, c.NEq, c.Gt, c.Gte, c.Lt, c.Lte, c.Between, c.NotBetween, c.In, c.NotIn],
  DateTime: [c.Eq, c.NEq, c.Gt, c.Gte, c.Lt, c.Lte, c.Between, c.NotBetween, c.In, c.NotIn],
  FilterValue: [c.Eq, c.NEq, c.Gt, c.Gte, c.Lt, c.Lte, c.Between, c.NotBetween, c.In, c.NotIn],
  JSON: [c.Eq, c.NEq, c.In, c.NotIn]
}, Il = {
  String: {
    default: ce,
    [c.Like]: te,
    [c.ILike]: te,
    [c.NotLike]: te,
    [c.NotILike]: te
  },
  ID: {
    default: (e) => e,
    [c.In]: (e) => w(e),
    [c.NotIn]: (e) => w(e),
    [c.Between]: (e) => w(e),
    [c.NotBetween]: (e) => w(e)
  },
  Int: {
    default: (e) => e,
    [c.In]: (e) => w(e),
    [c.NotIn]: (e) => w(e),
    [c.Between]: (e) => w(e),
    [c.NotBetween]: (e) => w(e)
  },
  DateTime: {
    default: (e) => ce(String(e)),
    [c.Between]: (e) => ie(e),
    [c.NotBetween]: (e) => ie(e),
    [c.In]: (e) => ie(e),
    [c.NotIn]: (e) => ie(e)
  }
};
function w(e) {
  return Array.isArray(e) ? `[${e.join(",")}]` : "";
}
function ie(e) {
  return Array.isArray(e) ? `[${e.map(ce).join(",")}]` : "";
}
function ce(e) {
  return typeof e != "string" ? e : (e = e.replace(/"/g, '\\"'), `"${e}"`);
}
function te(e) {
  return ce(`%${e}%`);
}
const Ee = JSON, fn = (e) => e.toUpperCase(), mn = (e) => {
  const n = {};
  return e.forEach((l, i) => {
    n[i] = l;
  }), n;
}, yn = (e, n, l) => e.document ? e : {
  document: e,
  variables: n,
  requestHeaders: l,
  signal: void 0
}, Tn = (e, n, l) => e.query ? e : {
  query: e,
  variables: n,
  requestHeaders: l,
  signal: void 0
}, Nn = (e, n) => e.documents ? e : {
  documents: e,
  requestHeaders: n,
  signal: void 0
};
function pe(e, n) {
  if (!!!e)
    throw new Error(n);
}
function Ln(e) {
  return typeof e == "object" && e !== null;
}
function kn(e, n) {
  if (!!!e)
    throw new Error(
      n ?? "Unexpected invariant triggered."
    );
}
const An = /\r\n|[\n\r]/g;
function _e(e, n) {
  let l = 0, i = 1;
  for (const a of e.body.matchAll(An)) {
    if (typeof a.index == "number" || kn(!1), a.index >= n)
      break;
    l = a.index + a[0].length, i += 1;
  }
  return {
    line: i,
    column: n + 1 - l
  };
}
function Rn(e) {
  return je(
    e.source,
    _e(e.source, e.start)
  );
}
function je(e, n) {
  const l = e.locationOffset.column - 1, i = "".padStart(l) + e.body, a = n.line - 1, t = e.locationOffset.line - 1, s = n.line + t, p = n.line === 1 ? l : 0, r = n.column + p, N = `${e.name}:${s}:${r}
`, f = i.split(/\r\n|[\n\r]/g), R = f[a];
  if (R.length > 120) {
    const L = Math.floor(r / 80), I = r % 80, A = [];
    for (let m = 0; m < R.length; m += 80)
      A.push(R.slice(m, m + 80));
    return N + qe([
      [`${s} |`, A[0]],
      ...A.slice(1, L + 1).map((m) => ["|", m]),
      ["|", "^".padStart(I)],
      ["|", A[L + 1]]
    ]);
  }
  return N + qe([
    // Lines specified like this: ["prefix", "string"],
    [`${s - 1} |`, f[a - 1]],
    [`${s} |`, R],
    ["|", "^".padStart(r)],
    [`${s + 1} |`, f[a + 1]]
  ]);
}
function qe(e) {
  const n = e.filter(([i, a]) => a !== void 0), l = Math.max(...n.map(([i]) => i.length));
  return n.map(([i, a]) => i.padStart(l) + (a ? " " + a : "")).join(`
`);
}
function Cn(e) {
  const n = e[0];
  return n == null || "kind" in n || "length" in n ? {
    nodes: n,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : n;
}
class he extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(n, ...l) {
    var i, a, t;
    const { nodes: s, source: p, positions: r, path: N, originalError: f, extensions: R } = Cn(l);
    super(n), this.name = "GraphQLError", this.path = N ?? void 0, this.originalError = f ?? void 0, this.nodes = Ge(
      Array.isArray(s) ? s : s ? [s] : void 0
    );
    const L = Ge(
      (i = this.nodes) === null || i === void 0 ? void 0 : i.map((A) => A.loc).filter((A) => A != null)
    );
    this.source = p ?? (L == null || (a = L[0]) === null || a === void 0 ? void 0 : a.source), this.positions = r ?? (L == null ? void 0 : L.map((A) => A.start)), this.locations = r && p ? r.map((A) => _e(p, A)) : L == null ? void 0 : L.map((A) => _e(A.source, A.start));
    const I = Ln(
      f == null ? void 0 : f.extensions
    ) ? f == null ? void 0 : f.extensions : void 0;
    this.extensions = (t = R ?? I) !== null && t !== void 0 ? t : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), f != null && f.stack ? Object.defineProperty(this, "stack", {
      value: f.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, he) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let n = this.message;
    if (this.nodes)
      for (const l of this.nodes)
        l.loc && (n += `

` + Rn(l.loc));
    else if (this.source && this.locations)
      for (const l of this.locations)
        n += `

` + je(this.source, l);
    return n;
  }
  toJSON() {
    const n = {
      message: this.message
    };
    return this.locations != null && (n.locations = this.locations), this.path != null && (n.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (n.extensions = this.extensions), n;
  }
}
function Ge(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function P(e, n, l) {
  return new he(`Syntax Error: ${l}`, {
    source: e,
    positions: [n]
  });
}
class gn {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(n, l, i) {
    this.start = n.start, this.end = l.end, this.startToken = n, this.endToken = l, this.source = i;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class He {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(n, l, i, a, t, s) {
    this.kind = n, this.start = l, this.end = i, this.line = a, this.column = t, this.value = s, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const Qe = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, On = new Set(Object.keys(Qe));
function ve(e) {
  const n = e == null ? void 0 : e.kind;
  return typeof n == "string" && On.has(n);
}
var Q;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(Q || (Q = {}));
var Se;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(Se || (Se = {}));
var k;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(k || (k = {}));
function Ue(e) {
  return e === 9 || e === 32;
}
function Z(e) {
  return e >= 48 && e <= 57;
}
function Ye(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function We(e) {
  return Ye(e) || e === 95;
}
function In(e) {
  return Ye(e) || Z(e) || e === 95;
}
function _n(e) {
  var n;
  let l = Number.MAX_SAFE_INTEGER, i = null, a = -1;
  for (let s = 0; s < e.length; ++s) {
    var t;
    const p = e[s], r = Sn(p);
    r !== p.length && (i = (t = i) !== null && t !== void 0 ? t : s, a = s, s !== 0 && r < l && (l = r));
  }
  return e.map((s, p) => p === 0 ? s : s.slice(l)).slice(
    (n = i) !== null && n !== void 0 ? n : 0,
    a + 1
  );
}
function Sn(e) {
  let n = 0;
  for (; n < e.length && Ue(e.charCodeAt(n)); )
    ++n;
  return n;
}
function Un(e, n) {
  const l = e.replace(/"""/g, '\\"""'), i = l.split(/\r\n|[\n\r]/g), a = i.length === 1, t = i.length > 1 && i.slice(1).every((I) => I.length === 0 || Ue(I.charCodeAt(0))), s = l.endsWith('\\"""'), p = e.endsWith('"') && !s, r = e.endsWith("\\"), N = p || r, f = !(n != null && n.minimize) && // add leading and trailing new lines only if it improves readability
  (!a || e.length > 70 || N || t || s);
  let R = "";
  const L = a && Ue(e.charCodeAt(0));
  return (f && !L || t) && (R += `
`), R += l, (f || N) && (R += `
`), '"""' + R + '"""';
}
var u;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(u || (u = {}));
class Dn {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(n) {
    const l = new He(u.SOF, 0, 0, 0, 0);
    this.source = n, this.lastToken = l, this.token = l, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let n = this.token;
    if (n.kind !== u.EOF)
      do
        if (n.next)
          n = n.next;
        else {
          const l = hn(this, n.end);
          n.next = l, l.prev = n, n = l;
        }
      while (n.kind === u.COMMENT);
    return n;
  }
}
function En(e) {
  return e === u.BANG || e === u.DOLLAR || e === u.AMP || e === u.PAREN_L || e === u.PAREN_R || e === u.SPREAD || e === u.COLON || e === u.EQUALS || e === u.AT || e === u.BRACKET_L || e === u.BRACKET_R || e === u.BRACE_L || e === u.PIPE || e === u.BRACE_R;
}
function W(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function me(e, n) {
  return ze(e.charCodeAt(n)) && Xe(e.charCodeAt(n + 1));
}
function ze(e) {
  return e >= 55296 && e <= 56319;
}
function Xe(e) {
  return e >= 56320 && e <= 57343;
}
function j(e, n) {
  const l = e.source.body.codePointAt(n);
  if (l === void 0)
    return u.EOF;
  if (l >= 32 && l <= 126) {
    const i = String.fromCodePoint(l);
    return i === '"' ? `'"'` : `"${i}"`;
  }
  return "U+" + l.toString(16).toUpperCase().padStart(4, "0");
}
function h(e, n, l, i, a) {
  const t = e.line, s = 1 + l - e.lineStart;
  return new He(n, l, i, t, s, a);
}
function hn(e, n) {
  const l = e.source.body, i = l.length;
  let a = n;
  for (; a < i; ) {
    const t = l.charCodeAt(a);
    switch (t) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++a;
        continue;
      case 10:
        ++a, ++e.line, e.lineStart = a;
        continue;
      case 13:
        l.charCodeAt(a + 1) === 10 ? a += 2 : ++a, ++e.line, e.lineStart = a;
        continue;
      case 35:
        return Pn(e, a);
      case 33:
        return h(e, u.BANG, a, a + 1);
      case 36:
        return h(e, u.DOLLAR, a, a + 1);
      case 38:
        return h(e, u.AMP, a, a + 1);
      case 40:
        return h(e, u.PAREN_L, a, a + 1);
      case 41:
        return h(e, u.PAREN_R, a, a + 1);
      case 46:
        if (l.charCodeAt(a + 1) === 46 && l.charCodeAt(a + 2) === 46)
          return h(e, u.SPREAD, a, a + 3);
        break;
      case 58:
        return h(e, u.COLON, a, a + 1);
      case 61:
        return h(e, u.EQUALS, a, a + 1);
      case 64:
        return h(e, u.AT, a, a + 1);
      case 91:
        return h(e, u.BRACKET_L, a, a + 1);
      case 93:
        return h(e, u.BRACKET_R, a, a + 1);
      case 123:
        return h(e, u.BRACE_L, a, a + 1);
      case 124:
        return h(e, u.PIPE, a, a + 1);
      case 125:
        return h(e, u.BRACE_R, a, a + 1);
      case 34:
        return l.charCodeAt(a + 1) === 34 && l.charCodeAt(a + 2) === 34 ? Gn(e, a) : Vn(e, a);
    }
    if (Z(t) || t === 45)
      return Bn(e, a, t);
    if (We(t))
      return vn(e, a);
    throw P(
      e.source,
      a,
      t === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : W(t) || me(l, a) ? `Unexpected character: ${j(e, a)}.` : `Invalid character: ${j(e, a)}.`
    );
  }
  return h(e, u.EOF, i, i);
}
function Pn(e, n) {
  const l = e.source.body, i = l.length;
  let a = n + 1;
  for (; a < i; ) {
    const t = l.charCodeAt(a);
    if (t === 10 || t === 13)
      break;
    if (W(t))
      ++a;
    else if (me(l, a))
      a += 2;
    else
      break;
  }
  return h(
    e,
    u.COMMENT,
    n,
    a,
    l.slice(n + 1, a)
  );
}
function Bn(e, n, l) {
  const i = e.source.body;
  let a = n, t = l, s = !1;
  if (t === 45 && (t = i.charCodeAt(++a)), t === 48) {
    if (t = i.charCodeAt(++a), Z(t))
      throw P(
        e.source,
        a,
        `Invalid number, unexpected digit after 0: ${j(
          e,
          a
        )}.`
      );
  } else
    a = Ce(e, a, t), t = i.charCodeAt(a);
  if (t === 46 && (s = !0, t = i.charCodeAt(++a), a = Ce(e, a, t), t = i.charCodeAt(a)), (t === 69 || t === 101) && (s = !0, t = i.charCodeAt(++a), (t === 43 || t === 45) && (t = i.charCodeAt(++a)), a = Ce(e, a, t), t = i.charCodeAt(a)), t === 46 || We(t))
    throw P(
      e.source,
      a,
      `Invalid number, expected digit but got: ${j(
        e,
        a
      )}.`
    );
  return h(
    e,
    s ? u.FLOAT : u.INT,
    n,
    a,
    i.slice(n, a)
  );
}
function Ce(e, n, l) {
  if (!Z(l))
    throw P(
      e.source,
      n,
      `Invalid number, expected digit but got: ${j(
        e,
        n
      )}.`
    );
  const i = e.source.body;
  let a = n + 1;
  for (; Z(i.charCodeAt(a)); )
    ++a;
  return a;
}
function Vn(e, n) {
  const l = e.source.body, i = l.length;
  let a = n + 1, t = a, s = "";
  for (; a < i; ) {
    const p = l.charCodeAt(a);
    if (p === 34)
      return s += l.slice(t, a), h(e, u.STRING, n, a + 1, s);
    if (p === 92) {
      s += l.slice(t, a);
      const r = l.charCodeAt(a + 1) === 117 ? l.charCodeAt(a + 2) === 123 ? Jn(e, a) : bn(e, a) : qn(e, a);
      s += r.value, a += r.size, t = a;
      continue;
    }
    if (p === 10 || p === 13)
      break;
    if (W(p))
      ++a;
    else if (me(l, a))
      a += 2;
    else
      throw P(
        e.source,
        a,
        `Invalid character within String: ${j(
          e,
          a
        )}.`
      );
  }
  throw P(e.source, a, "Unterminated string.");
}
function Jn(e, n) {
  const l = e.source.body;
  let i = 0, a = 3;
  for (; a < 12; ) {
    const t = l.charCodeAt(n + a++);
    if (t === 125) {
      if (a < 5 || !W(i))
        break;
      return {
        value: String.fromCodePoint(i),
        size: a
      };
    }
    if (i = i << 4 | z(t), i < 0)
      break;
  }
  throw P(
    e.source,
    n,
    `Invalid Unicode escape sequence: "${l.slice(
      n,
      n + a
    )}".`
  );
}
function bn(e, n) {
  const l = e.source.body, i = Fe(l, n + 2);
  if (W(i))
    return {
      value: String.fromCodePoint(i),
      size: 6
    };
  if (ze(i) && l.charCodeAt(n + 6) === 92 && l.charCodeAt(n + 7) === 117) {
    const a = Fe(l, n + 8);
    if (Xe(a))
      return {
        value: String.fromCodePoint(i, a),
        size: 12
      };
  }
  throw P(
    e.source,
    n,
    `Invalid Unicode escape sequence: "${l.slice(n, n + 6)}".`
  );
}
function Fe(e, n) {
  return z(e.charCodeAt(n)) << 12 | z(e.charCodeAt(n + 1)) << 8 | z(e.charCodeAt(n + 2)) << 4 | z(e.charCodeAt(n + 3));
}
function z(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function qn(e, n) {
  const l = e.source.body;
  switch (l.charCodeAt(n + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw P(
    e.source,
    n,
    `Invalid character escape sequence: "${l.slice(
      n,
      n + 2
    )}".`
  );
}
function Gn(e, n) {
  const l = e.source.body, i = l.length;
  let a = e.lineStart, t = n + 3, s = t, p = "";
  const r = [];
  for (; t < i; ) {
    const N = l.charCodeAt(t);
    if (N === 34 && l.charCodeAt(t + 1) === 34 && l.charCodeAt(t + 2) === 34) {
      p += l.slice(s, t), r.push(p);
      const f = h(
        e,
        u.BLOCK_STRING,
        n,
        t + 3,
        // Return a string of the lines joined with U+000A.
        _n(r).join(`
`)
      );
      return e.line += r.length - 1, e.lineStart = a, f;
    }
    if (N === 92 && l.charCodeAt(t + 1) === 34 && l.charCodeAt(t + 2) === 34 && l.charCodeAt(t + 3) === 34) {
      p += l.slice(s, t), s = t + 1, t += 4;
      continue;
    }
    if (N === 10 || N === 13) {
      p += l.slice(s, t), r.push(p), N === 13 && l.charCodeAt(t + 1) === 10 ? t += 2 : ++t, p = "", s = t, a = t;
      continue;
    }
    if (W(N))
      ++t;
    else if (me(l, t))
      t += 2;
    else
      throw P(
        e.source,
        t,
        `Invalid character within String: ${j(
          e,
          t
        )}.`
      );
  }
  throw P(e.source, t, "Unterminated string.");
}
function vn(e, n) {
  const l = e.source.body, i = l.length;
  let a = n + 1;
  for (; a < i; ) {
    const t = l.charCodeAt(a);
    if (In(t))
      ++a;
    else
      break;
  }
  return h(
    e,
    u.NAME,
    n,
    a,
    l.slice(n, a)
  );
}
const Fn = 10, Ke = 2;
function Pe(e) {
  return ye(e, []);
}
function ye(e, n) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return xn(e, n);
    default:
      return String(e);
  }
}
function xn(e, n) {
  if (e === null)
    return "null";
  if (n.includes(e))
    return "[Circular]";
  const l = [...n, e];
  if (wn(e)) {
    const i = e.toJSON();
    if (i !== e)
      return typeof i == "string" ? i : ye(i, l);
  } else if (Array.isArray(e))
    return $n(e, l);
  return Mn(e, l);
}
function wn(e) {
  return typeof e.toJSON == "function";
}
function Mn(e, n) {
  const l = Object.entries(e);
  return l.length === 0 ? "{}" : n.length > Ke ? "[" + jn(e) + "]" : "{ " + l.map(
    ([a, t]) => a + ": " + ye(t, n)
  ).join(", ") + " }";
}
function $n(e, n) {
  if (e.length === 0)
    return "[]";
  if (n.length > Ke)
    return "[Array]";
  const l = Math.min(Fn, e.length), i = e.length - l, a = [];
  for (let t = 0; t < l; ++t)
    a.push(ye(e[t], n));
  return i === 1 ? a.push("... 1 more item") : i > 1 && a.push(`... ${i} more items`), "[" + a.join(", ") + "]";
}
function jn(e) {
  const n = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (n === "Object" && typeof e.constructor == "function") {
    const l = e.constructor.name;
    if (typeof l == "string" && l !== "")
      return l;
  }
  return n;
}
const Hn = globalThis.process && // eslint-disable-next-line no-undef
process.env.NODE_ENV === "production", Qn = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  Hn ? function(n, l) {
    return n instanceof l;
  } : function(n, l) {
    if (n instanceof l)
      return !0;
    if (typeof n == "object" && n !== null) {
      var i;
      const a = l.prototype[Symbol.toStringTag], t = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in n ? n[Symbol.toStringTag] : (i = n.constructor) === null || i === void 0 ? void 0 : i.name
      );
      if (a === t) {
        const s = Pe(n);
        throw new Error(`Cannot use ${a} "${s}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class Ze {
  constructor(n, l = "GraphQL request", i = {
    line: 1,
    column: 1
  }) {
    typeof n == "string" || pe(!1, `Body must be a string. Received: ${Pe(n)}.`), this.body = n, this.name = l, this.locationOffset = i, this.locationOffset.line > 0 || pe(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || pe(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function Yn(e) {
  return Qn(e, Ze);
}
function Wn(e, n) {
  const l = new zn(e, n), i = l.parseDocument();
  return Object.defineProperty(i, "tokenCount", {
    enumerable: !1,
    value: l.tokenCount
  }), i;
}
class zn {
  constructor(n, l = {}) {
    const i = Yn(n) ? n : new Ze(n);
    this._lexer = new Dn(i), this._options = l, this._tokenCounter = 0;
  }
  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const n = this.expectToken(u.NAME);
    return this.node(n, {
      kind: k.NAME,
      value: n.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: k.DOCUMENT,
      definitions: this.many(
        u.SOF,
        this.parseDefinition,
        u.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(u.BRACE_L))
      return this.parseOperationDefinition();
    const n = this.peekDescription(), l = n ? this._lexer.lookahead() : this._lexer.token;
    if (l.kind === u.NAME) {
      switch (l.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (n)
        throw P(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (l.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(l);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const n = this._lexer.token;
    if (this.peek(u.BRACE_L))
      return this.node(n, {
        kind: k.OPERATION_DEFINITION,
        operation: Q.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const l = this.parseOperationType();
    let i;
    return this.peek(u.NAME) && (i = this.parseName()), this.node(n, {
      kind: k.OPERATION_DEFINITION,
      operation: l,
      name: i,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const n = this.expectToken(u.NAME);
    switch (n.value) {
      case "query":
        return Q.QUERY;
      case "mutation":
        return Q.MUTATION;
      case "subscription":
        return Q.SUBSCRIPTION;
    }
    throw this.unexpected(n);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      u.PAREN_L,
      this.parseVariableDefinition,
      u.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: k.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(u.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(u.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const n = this._lexer.token;
    return this.expectToken(u.DOLLAR), this.node(n, {
      kind: k.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: k.SELECTION_SET,
      selections: this.many(
        u.BRACE_L,
        this.parseSelection,
        u.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(u.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const n = this._lexer.token, l = this.parseName();
    let i, a;
    return this.expectOptionalToken(u.COLON) ? (i = l, a = this.parseName()) : a = l, this.node(n, {
      kind: k.FIELD,
      alias: i,
      name: a,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(u.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(n) {
    const l = n ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(u.PAREN_L, l, u.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(n = !1) {
    const l = this._lexer.token, i = this.parseName();
    return this.expectToken(u.COLON), this.node(l, {
      kind: k.ARGUMENT,
      name: i,
      value: this.parseValueLiteral(n)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const n = this._lexer.token;
    this.expectToken(u.SPREAD);
    const l = this.expectOptionalKeyword("on");
    return !l && this.peek(u.NAME) ? this.node(n, {
      kind: k.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(n, {
      kind: k.INLINE_FRAGMENT,
      typeCondition: l ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const n = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(n, {
      kind: k.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(n, {
      kind: k.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(n) {
    const l = this._lexer.token;
    switch (l.kind) {
      case u.BRACKET_L:
        return this.parseList(n);
      case u.BRACE_L:
        return this.parseObject(n);
      case u.INT:
        return this.advanceLexer(), this.node(l, {
          kind: k.INT,
          value: l.value
        });
      case u.FLOAT:
        return this.advanceLexer(), this.node(l, {
          kind: k.FLOAT,
          value: l.value
        });
      case u.STRING:
      case u.BLOCK_STRING:
        return this.parseStringLiteral();
      case u.NAME:
        switch (this.advanceLexer(), l.value) {
          case "true":
            return this.node(l, {
              kind: k.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(l, {
              kind: k.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(l, {
              kind: k.NULL
            });
          default:
            return this.node(l, {
              kind: k.ENUM,
              value: l.value
            });
        }
      case u.DOLLAR:
        if (n)
          if (this.expectToken(u.DOLLAR), this._lexer.token.kind === u.NAME) {
            const i = this._lexer.token.value;
            throw P(
              this._lexer.source,
              l.start,
              `Unexpected variable "$${i}" in constant value.`
            );
          } else
            throw this.unexpected(l);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const n = this._lexer.token;
    return this.advanceLexer(), this.node(n, {
      kind: k.STRING,
      value: n.value,
      block: n.kind === u.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(n) {
    const l = () => this.parseValueLiteral(n);
    return this.node(this._lexer.token, {
      kind: k.LIST,
      values: this.any(u.BRACKET_L, l, u.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(n) {
    const l = () => this.parseObjectField(n);
    return this.node(this._lexer.token, {
      kind: k.OBJECT,
      fields: this.any(u.BRACE_L, l, u.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(n) {
    const l = this._lexer.token, i = this.parseName();
    return this.expectToken(u.COLON), this.node(l, {
      kind: k.OBJECT_FIELD,
      name: i,
      value: this.parseValueLiteral(n)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(n) {
    const l = [];
    for (; this.peek(u.AT); )
      l.push(this.parseDirective(n));
    return l;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(n) {
    const l = this._lexer.token;
    return this.expectToken(u.AT), this.node(l, {
      kind: k.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(n)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const n = this._lexer.token;
    let l;
    if (this.expectOptionalToken(u.BRACKET_L)) {
      const i = this.parseTypeReference();
      this.expectToken(u.BRACKET_R), l = this.node(n, {
        kind: k.LIST_TYPE,
        type: i
      });
    } else
      l = this.parseNamedType();
    return this.expectOptionalToken(u.BANG) ? this.node(n, {
      kind: k.NON_NULL_TYPE,
      type: l
    }) : l;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: k.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(u.STRING) || this.peek(u.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const n = this._lexer.token, l = this.parseDescription();
    this.expectKeyword("schema");
    const i = this.parseConstDirectives(), a = this.many(
      u.BRACE_L,
      this.parseOperationTypeDefinition,
      u.BRACE_R
    );
    return this.node(n, {
      kind: k.SCHEMA_DEFINITION,
      description: l,
      directives: i,
      operationTypes: a
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const n = this._lexer.token, l = this.parseOperationType();
    this.expectToken(u.COLON);
    const i = this.parseNamedType();
    return this.node(n, {
      kind: k.OPERATION_TYPE_DEFINITION,
      operation: l,
      type: i
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const n = this._lexer.token, l = this.parseDescription();
    this.expectKeyword("scalar");
    const i = this.parseName(), a = this.parseConstDirectives();
    return this.node(n, {
      kind: k.SCALAR_TYPE_DEFINITION,
      description: l,
      name: i,
      directives: a
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const n = this._lexer.token, l = this.parseDescription();
    this.expectKeyword("type");
    const i = this.parseName(), a = this.parseImplementsInterfaces(), t = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(n, {
      kind: k.OBJECT_TYPE_DEFINITION,
      description: l,
      name: i,
      interfaces: a,
      directives: t,
      fields: s
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(u.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      u.BRACE_L,
      this.parseFieldDefinition,
      u.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const n = this._lexer.token, l = this.parseDescription(), i = this.parseName(), a = this.parseArgumentDefs();
    this.expectToken(u.COLON);
    const t = this.parseTypeReference(), s = this.parseConstDirectives();
    return this.node(n, {
      kind: k.FIELD_DEFINITION,
      description: l,
      name: i,
      arguments: a,
      type: t,
      directives: s
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      u.PAREN_L,
      this.parseInputValueDef,
      u.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const n = this._lexer.token, l = this.parseDescription(), i = this.parseName();
    this.expectToken(u.COLON);
    const a = this.parseTypeReference();
    let t;
    this.expectOptionalToken(u.EQUALS) && (t = this.parseConstValueLiteral());
    const s = this.parseConstDirectives();
    return this.node(n, {
      kind: k.INPUT_VALUE_DEFINITION,
      description: l,
      name: i,
      type: a,
      defaultValue: t,
      directives: s
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const n = this._lexer.token, l = this.parseDescription();
    this.expectKeyword("interface");
    const i = this.parseName(), a = this.parseImplementsInterfaces(), t = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(n, {
      kind: k.INTERFACE_TYPE_DEFINITION,
      description: l,
      name: i,
      interfaces: a,
      directives: t,
      fields: s
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const n = this._lexer.token, l = this.parseDescription();
    this.expectKeyword("union");
    const i = this.parseName(), a = this.parseConstDirectives(), t = this.parseUnionMemberTypes();
    return this.node(n, {
      kind: k.UNION_TYPE_DEFINITION,
      description: l,
      name: i,
      directives: a,
      types: t
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(u.EQUALS) ? this.delimitedMany(u.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const n = this._lexer.token, l = this.parseDescription();
    this.expectKeyword("enum");
    const i = this.parseName(), a = this.parseConstDirectives(), t = this.parseEnumValuesDefinition();
    return this.node(n, {
      kind: k.ENUM_TYPE_DEFINITION,
      description: l,
      name: i,
      directives: a,
      values: t
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      u.BRACE_L,
      this.parseEnumValueDefinition,
      u.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const n = this._lexer.token, l = this.parseDescription(), i = this.parseEnumValueName(), a = this.parseConstDirectives();
    return this.node(n, {
      kind: k.ENUM_VALUE_DEFINITION,
      description: l,
      name: i,
      directives: a
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw P(
        this._lexer.source,
        this._lexer.token.start,
        `${oe(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const n = this._lexer.token, l = this.parseDescription();
    this.expectKeyword("input");
    const i = this.parseName(), a = this.parseConstDirectives(), t = this.parseInputFieldsDefinition();
    return this.node(n, {
      kind: k.INPUT_OBJECT_TYPE_DEFINITION,
      description: l,
      name: i,
      directives: a,
      fields: t
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      u.BRACE_L,
      this.parseInputValueDef,
      u.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const n = this._lexer.lookahead();
    if (n.kind === u.NAME)
      switch (n.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(n);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const l = this.parseConstDirectives(), i = this.optionalMany(
      u.BRACE_L,
      this.parseOperationTypeDefinition,
      u.BRACE_R
    );
    if (l.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: k.SCHEMA_EXTENSION,
      directives: l,
      operationTypes: i
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const l = this.parseName(), i = this.parseConstDirectives();
    if (i.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: k.SCALAR_TYPE_EXTENSION,
      name: l,
      directives: i
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const l = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), t = this.parseFieldsDefinition();
    if (i.length === 0 && a.length === 0 && t.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: k.OBJECT_TYPE_EXTENSION,
      name: l,
      interfaces: i,
      directives: a,
      fields: t
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const l = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), t = this.parseFieldsDefinition();
    if (i.length === 0 && a.length === 0 && t.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: k.INTERFACE_TYPE_EXTENSION,
      name: l,
      interfaces: i,
      directives: a,
      fields: t
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const l = this.parseName(), i = this.parseConstDirectives(), a = this.parseUnionMemberTypes();
    if (i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: k.UNION_TYPE_EXTENSION,
      name: l,
      directives: i,
      types: a
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const l = this.parseName(), i = this.parseConstDirectives(), a = this.parseEnumValuesDefinition();
    if (i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: k.ENUM_TYPE_EXTENSION,
      name: l,
      directives: i,
      values: a
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const l = this.parseName(), i = this.parseConstDirectives(), a = this.parseInputFieldsDefinition();
    if (i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: k.INPUT_OBJECT_TYPE_EXTENSION,
      name: l,
      directives: i,
      fields: a
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const n = this._lexer.token, l = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(u.AT);
    const i = this.parseName(), a = this.parseArgumentDefs(), t = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const s = this.parseDirectiveLocations();
    return this.node(n, {
      kind: k.DIRECTIVE_DEFINITION,
      description: l,
      name: i,
      arguments: a,
      repeatable: t,
      locations: s
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(u.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const n = this._lexer.token, l = this.parseName();
    if (Object.prototype.hasOwnProperty.call(Se, l.value))
      return l;
    throw this.unexpected(n);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(n, l) {
    return this._options.noLocation !== !0 && (l.loc = new gn(
      n,
      this._lexer.lastToken,
      this._lexer.source
    )), l;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(n) {
    return this._lexer.token.kind === n;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(n) {
    const l = this._lexer.token;
    if (l.kind === n)
      return this.advanceLexer(), l;
    throw P(
      this._lexer.source,
      l.start,
      `Expected ${en(n)}, found ${oe(l)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(n) {
    return this._lexer.token.kind === n ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(n) {
    const l = this._lexer.token;
    if (l.kind === u.NAME && l.value === n)
      this.advanceLexer();
    else
      throw P(
        this._lexer.source,
        l.start,
        `Expected "${n}", found ${oe(l)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(n) {
    const l = this._lexer.token;
    return l.kind === u.NAME && l.value === n ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(n) {
    const l = n ?? this._lexer.token;
    return P(
      this._lexer.source,
      l.start,
      `Unexpected ${oe(l)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(n, l, i) {
    this.expectToken(n);
    const a = [];
    for (; !this.expectOptionalToken(i); )
      a.push(l.call(this));
    return a;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(n, l, i) {
    if (this.expectOptionalToken(n)) {
      const a = [];
      do
        a.push(l.call(this));
      while (!this.expectOptionalToken(i));
      return a;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(n, l, i) {
    this.expectToken(n);
    const a = [];
    do
      a.push(l.call(this));
    while (!this.expectOptionalToken(i));
    return a;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(n, l) {
    this.expectOptionalToken(n);
    const i = [];
    do
      i.push(l.call(this));
    while (this.expectOptionalToken(n));
    return i;
  }
  advanceLexer() {
    const { maxTokens: n } = this._options, l = this._lexer.advance();
    if (l.kind !== u.EOF && (++this._tokenCounter, n !== void 0 && this._tokenCounter > n))
      throw P(
        this._lexer.source,
        l.start,
        `Document contains more that ${n} tokens. Parsing aborted.`
      );
  }
}
function oe(e) {
  const n = e.value;
  return en(e.kind) + (n != null ? ` "${n}"` : "");
}
function en(e) {
  return En(e) ? `"${e}"` : e;
}
function Xn(e) {
  return `"${e.replace(Kn, Zn)}"`;
}
const Kn = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function Zn(e) {
  return el[e.charCodeAt(0)];
}
const el = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], nl = Object.freeze({});
function ll(e, n, l = Qe) {
  const i = /* @__PURE__ */ new Map();
  for (const T of Object.values(k))
    i.set(T, al(n, T));
  let a, t = Array.isArray(e), s = [e], p = -1, r = [], N = e, f, R;
  const L = [], I = [];
  do {
    p++;
    const T = p === s.length, _ = T && r.length !== 0;
    if (T) {
      if (f = I.length === 0 ? void 0 : L[L.length - 1], N = R, R = I.pop(), _)
        if (t) {
          N = N.slice();
          let q = 0;
          for (const [B, b] of r) {
            const J = B - q;
            b === null ? (N.splice(J, 1), q++) : N[J] = b;
          }
        } else {
          N = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(N)
          );
          for (const [q, B] of r)
            N[q] = B;
        }
      p = a.index, s = a.keys, r = a.edits, t = a.inArray, a = a.prev;
    } else if (R) {
      if (f = t ? p : s[p], N = R[f], N == null)
        continue;
      L.push(f);
    }
    let D;
    if (!Array.isArray(N)) {
      var A, m;
      ve(N) || pe(!1, `Invalid AST Node: ${Pe(N)}.`);
      const q = T ? (A = i.get(N.kind)) === null || A === void 0 ? void 0 : A.leave : (m = i.get(N.kind)) === null || m === void 0 ? void 0 : m.enter;
      if (D = q == null ? void 0 : q.call(n, N, f, R, L, I), D === nl)
        break;
      if (D === !1) {
        if (!T) {
          L.pop();
          continue;
        }
      } else if (D !== void 0 && (r.push([f, D]), !T))
        if (ve(D))
          N = D;
        else {
          L.pop();
          continue;
        }
    }
    if (D === void 0 && _ && r.push([f, N]), T)
      L.pop();
    else {
      var C;
      a = {
        inArray: t,
        index: p,
        keys: s,
        edits: r,
        prev: a
      }, t = Array.isArray(N), s = t ? N : (C = l[N.kind]) !== null && C !== void 0 ? C : [], p = -1, r = [], R && I.push(R), R = N;
    }
  } while (a !== void 0);
  return r.length !== 0 ? r[r.length - 1][1] : e;
}
function al(e, n) {
  const l = e[n];
  return typeof l == "object" ? l : typeof l == "function" ? {
    enter: l,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function il(e) {
  return ll(e, ol);
}
const tl = 80, ol = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => y(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const n = O("(", y(e.variableDefinitions, ", "), ")"), l = y(
        [
          e.operation,
          y([e.name, n]),
          y(e.directives, " ")
        ],
        " "
      );
      return (l === "query" ? "" : l + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: n, defaultValue: l, directives: i }) => e + ": " + n + O(" = ", l) + O(" ", y(i, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => v(e)
  },
  Field: {
    leave({ alias: e, name: n, arguments: l, directives: i, selectionSet: a }) {
      const t = O("", e, ": ") + n;
      let s = t + O("(", y(l, ", "), ")");
      return s.length > tl && (s = t + O(`(
`, de(y(l, `
`)), `
)`)), y([s, y(i, " "), a], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: n }) => e + ": " + n
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: n }) => "..." + e + O(" ", y(n, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: n, selectionSet: l }) => y(
      [
        "...",
        O("on ", e),
        y(n, " "),
        l
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: e, typeCondition: n, variableDefinitions: l, directives: i, selectionSet: a }) => (
      // or removed in the future.
      `fragment ${e}${O("(", y(l, ", "), ")")} on ${n} ${O("", y(i, " "), " ")}` + a
    )
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: n }) => n ? Un(e) : Xn(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + y(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + y(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: n }) => e + ": " + n
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: n }) => "@" + e + O("(", y(n, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: n, operationTypes: l }) => O("", e, `
`) + y(["schema", y(n, " "), v(l)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: n }) => e + ": " + n
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: n, directives: l }) => O("", e, `
`) + y(["scalar", n, y(l, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: n, interfaces: l, directives: i, fields: a }) => O("", e, `
`) + y(
      [
        "type",
        n,
        O("implements ", y(l, " & ")),
        y(i, " "),
        v(a)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: n, arguments: l, type: i, directives: a }) => O("", e, `
`) + n + (xe(l) ? O(`(
`, de(y(l, `
`)), `
)`) : O("(", y(l, ", "), ")")) + ": " + i + O(" ", y(a, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: n, type: l, defaultValue: i, directives: a }) => O("", e, `
`) + y(
      [n + ": " + l, O("= ", i), y(a, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: n, interfaces: l, directives: i, fields: a }) => O("", e, `
`) + y(
      [
        "interface",
        n,
        O("implements ", y(l, " & ")),
        y(i, " "),
        v(a)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: n, directives: l, types: i }) => O("", e, `
`) + y(
      ["union", n, y(l, " "), O("= ", y(i, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: n, directives: l, values: i }) => O("", e, `
`) + y(["enum", n, y(l, " "), v(i)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: n, directives: l }) => O("", e, `
`) + y([n, y(l, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: n, directives: l, fields: i }) => O("", e, `
`) + y(["input", n, y(l, " "), v(i)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: n, arguments: l, repeatable: i, locations: a }) => O("", e, `
`) + "directive @" + n + (xe(l) ? O(`(
`, de(y(l, `
`)), `
)`) : O("(", y(l, ", "), ")")) + (i ? " repeatable" : "") + " on " + y(a, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: n }) => y(
      ["extend schema", y(e, " "), v(n)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: n }) => y(["extend scalar", e, y(n, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: n, directives: l, fields: i }) => y(
      [
        "extend type",
        e,
        O("implements ", y(n, " & ")),
        y(l, " "),
        v(i)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: n, directives: l, fields: i }) => y(
      [
        "extend interface",
        e,
        O("implements ", y(n, " & ")),
        y(l, " "),
        v(i)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: n, types: l }) => y(
      [
        "extend union",
        e,
        y(n, " "),
        O("= ", y(l, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: n, values: l }) => y(["extend enum", e, y(n, " "), v(l)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: n, fields: l }) => y(["extend input", e, y(n, " "), v(l)], " ")
  }
};
function y(e, n = "") {
  var l;
  return (l = e == null ? void 0 : e.filter((i) => i).join(n)) !== null && l !== void 0 ? l : "";
}
function v(e) {
  return O(`{
`, de(y(e, `
`)), `
}`);
}
function O(e, n, l = "") {
  return n != null && n !== "" ? e + n + l : "";
}
function de(e) {
  return O("  ", e.replace(/\n/g, `
  `));
}
function xe(e) {
  var n;
  return (n = e == null ? void 0 : e.some((l) => l.includes(`
`))) !== null && n !== void 0 ? n : !1;
}
const we = (e) => {
  var i, a;
  let n;
  const l = e.definitions.filter((t) => t.kind === "OperationDefinition");
  return l.length === 1 && (n = (a = (i = l[0]) == null ? void 0 : i.name) == null ? void 0 : a.value), n;
}, ge = (e) => {
  if (typeof e == "string") {
    let l;
    try {
      const i = Wn(e);
      l = we(i);
    } catch {
    }
    return { query: e, operationName: l };
  }
  const n = we(e);
  return { query: il(e), operationName: n };
};
class K extends Error {
  constructor(n, l) {
    const i = `${K.extractMessage(n)}: ${JSON.stringify({
      response: n,
      request: l
    })}`;
    super(i), Object.setPrototypeOf(this, K.prototype), this.response = n, this.request = l, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, K);
  }
  static extractMessage(n) {
    var l, i;
    return ((i = (l = n.errors) == null ? void 0 : l[0]) == null ? void 0 : i.message) ?? `GraphQL Error (Code: ${n.status})`;
  }
}
var se = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function sl(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var De = { exports: {} };
(function(e, n) {
  var l = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof se < "u" && se, i = function() {
    function t() {
      this.fetch = !1, this.DOMException = l.DOMException;
    }
    return t.prototype = l, new t();
  }();
  (function(t) {
    (function(s) {
      var p = typeof t < "u" && t || typeof self < "u" && self || // eslint-disable-next-line no-undef
      typeof se < "u" && se || {}, r = {
        searchParams: "URLSearchParams" in p,
        iterable: "Symbol" in p && "iterator" in Symbol,
        blob: "FileReader" in p && "Blob" in p && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in p,
        arrayBuffer: "ArrayBuffer" in p
      };
      function N(o) {
        return o && DataView.prototype.isPrototypeOf(o);
      }
      if (r.arrayBuffer)
        var f = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], R = ArrayBuffer.isView || function(o) {
          return o && f.indexOf(Object.prototype.toString.call(o)) > -1;
        };
      function L(o) {
        if (typeof o != "string" && (o = String(o)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(o) || o === "")
          throw new TypeError('Invalid character in header field name: "' + o + '"');
        return o.toLowerCase();
      }
      function I(o) {
        return typeof o != "string" && (o = String(o)), o;
      }
      function A(o) {
        var d = {
          next: function() {
            var g = o.shift();
            return { done: g === void 0, value: g };
          }
        };
        return r.iterable && (d[Symbol.iterator] = function() {
          return d;
        }), d;
      }
      function m(o) {
        this.map = {}, o instanceof m ? o.forEach(function(d, g) {
          this.append(g, d);
        }, this) : Array.isArray(o) ? o.forEach(function(d) {
          if (d.length != 2)
            throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + d.length);
          this.append(d[0], d[1]);
        }, this) : o && Object.getOwnPropertyNames(o).forEach(function(d) {
          this.append(d, o[d]);
        }, this);
      }
      m.prototype.append = function(o, d) {
        o = L(o), d = I(d);
        var g = this.map[o];
        this.map[o] = g ? g + ", " + d : d;
      }, m.prototype.delete = function(o) {
        delete this.map[L(o)];
      }, m.prototype.get = function(o) {
        return o = L(o), this.has(o) ? this.map[o] : null;
      }, m.prototype.has = function(o) {
        return this.map.hasOwnProperty(L(o));
      }, m.prototype.set = function(o, d) {
        this.map[L(o)] = I(d);
      }, m.prototype.forEach = function(o, d) {
        for (var g in this.map)
          this.map.hasOwnProperty(g) && o.call(d, this.map[g], g, this);
      }, m.prototype.keys = function() {
        var o = [];
        return this.forEach(function(d, g) {
          o.push(g);
        }), A(o);
      }, m.prototype.values = function() {
        var o = [];
        return this.forEach(function(d) {
          o.push(d);
        }), A(o);
      }, m.prototype.entries = function() {
        var o = [];
        return this.forEach(function(d, g) {
          o.push([g, d]);
        }), A(o);
      }, r.iterable && (m.prototype[Symbol.iterator] = m.prototype.entries);
      function C(o) {
        if (!o._noBody) {
          if (o.bodyUsed)
            return Promise.reject(new TypeError("Already read"));
          o.bodyUsed = !0;
        }
      }
      function T(o) {
        return new Promise(function(d, g) {
          o.onload = function() {
            d(o.result);
          }, o.onerror = function() {
            g(o.error);
          };
        });
      }
      function _(o) {
        var d = new FileReader(), g = T(d);
        return d.readAsArrayBuffer(o), g;
      }
      function D(o) {
        var d = new FileReader(), g = T(d), U = /charset=([A-Za-z0-9_-]+)/.exec(o.type), E = U ? U[1] : "utf-8";
        return d.readAsText(o, E), g;
      }
      function q(o) {
        for (var d = new Uint8Array(o), g = new Array(d.length), U = 0; U < d.length; U++)
          g[U] = String.fromCharCode(d[U]);
        return g.join("");
      }
      function B(o) {
        if (o.slice)
          return o.slice(0);
        var d = new Uint8Array(o.byteLength);
        return d.set(new Uint8Array(o)), d.buffer;
      }
      function b() {
        return this.bodyUsed = !1, this._initBody = function(o) {
          this.bodyUsed = this.bodyUsed, this._bodyInit = o, o ? typeof o == "string" ? this._bodyText = o : r.blob && Blob.prototype.isPrototypeOf(o) ? this._bodyBlob = o : r.formData && FormData.prototype.isPrototypeOf(o) ? this._bodyFormData = o : r.searchParams && URLSearchParams.prototype.isPrototypeOf(o) ? this._bodyText = o.toString() : r.arrayBuffer && r.blob && N(o) ? (this._bodyArrayBuffer = B(o.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : r.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(o) || R(o)) ? this._bodyArrayBuffer = B(o) : this._bodyText = o = Object.prototype.toString.call(o) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || (typeof o == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : r.searchParams && URLSearchParams.prototype.isPrototypeOf(o) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, r.blob && (this.blob = function() {
          var o = C(this);
          if (o)
            return o;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }), this.arrayBuffer = function() {
          if (this._bodyArrayBuffer) {
            var o = C(this);
            return o || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
              this._bodyArrayBuffer.buffer.slice(
                this._bodyArrayBuffer.byteOffset,
                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
              )
            ) : Promise.resolve(this._bodyArrayBuffer));
          } else {
            if (r.blob)
              return this.blob().then(_);
            throw new Error("could not read as ArrayBuffer");
          }
        }, this.text = function() {
          var o = C(this);
          if (o)
            return o;
          if (this._bodyBlob)
            return D(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(q(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, r.formData && (this.formData = function() {
          return this.text().then(ne);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var J = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
      function x(o) {
        var d = o.toUpperCase();
        return J.indexOf(d) > -1 ? d : o;
      }
      function F(o, d) {
        if (!(this instanceof F))
          throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        d = d || {};
        var g = d.body;
        if (o instanceof F) {
          if (o.bodyUsed)
            throw new TypeError("Already read");
          this.url = o.url, this.credentials = o.credentials, d.headers || (this.headers = new m(o.headers)), this.method = o.method, this.mode = o.mode, this.signal = o.signal, !g && o._bodyInit != null && (g = o._bodyInit, o.bodyUsed = !0);
        } else
          this.url = String(o);
        if (this.credentials = d.credentials || this.credentials || "same-origin", (d.headers || !this.headers) && (this.headers = new m(d.headers)), this.method = x(d.method || this.method || "GET"), this.mode = d.mode || this.mode || null, this.signal = d.signal || this.signal || function() {
          if ("AbortController" in p) {
            var S = new AbortController();
            return S.signal;
          }
        }(), this.referrer = null, (this.method === "GET" || this.method === "HEAD") && g)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        if (this._initBody(g), (this.method === "GET" || this.method === "HEAD") && (d.cache === "no-store" || d.cache === "no-cache")) {
          var U = /([?&])_=[^&]*/;
          if (U.test(this.url))
            this.url = this.url.replace(U, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
          else {
            var E = /\?/;
            this.url += (E.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
          }
        }
      }
      F.prototype.clone = function() {
        return new F(this, { body: this._bodyInit });
      };
      function ne(o) {
        var d = new FormData();
        return o.trim().split("&").forEach(function(g) {
          if (g) {
            var U = g.split("="), E = U.shift().replace(/\+/g, " "), S = U.join("=").replace(/\+/g, " ");
            d.append(decodeURIComponent(E), decodeURIComponent(S));
          }
        }), d;
      }
      function le(o) {
        var d = new m(), g = o.replace(/\r?\n[\t ]+/g, " ");
        return g.split("\r").map(function(U) {
          return U.indexOf(`
`) === 0 ? U.substr(1, U.length) : U;
        }).forEach(function(U) {
          var E = U.split(":"), S = E.shift().trim();
          if (S) {
            var ae = E.join(":").trim();
            try {
              d.append(S, ae);
            } catch (Re) {
              console.warn("Response " + Re.message);
            }
          }
        }), d;
      }
      b.call(F.prototype);
      function G(o, d) {
        if (!(this instanceof G))
          throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        if (d || (d = {}), this.type = "default", this.status = d.status === void 0 ? 200 : d.status, this.status < 200 || this.status > 599)
          throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
        this.ok = this.status >= 200 && this.status < 300, this.statusText = d.statusText === void 0 ? "" : "" + d.statusText, this.headers = new m(d.headers), this.url = d.url || "", this._initBody(o);
      }
      b.call(G.prototype), G.prototype.clone = function() {
        return new G(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new m(this.headers),
          url: this.url
        });
      }, G.error = function() {
        var o = new G(null, { status: 200, statusText: "" });
        return o.ok = !1, o.status = 0, o.type = "error", o;
      };
      var sn = [301, 302, 303, 307, 308];
      G.redirect = function(o, d) {
        if (sn.indexOf(d) === -1)
          throw new RangeError("Invalid status code");
        return new G(null, { status: d, headers: { location: o } });
      }, s.DOMException = p.DOMException;
      try {
        new s.DOMException();
      } catch {
        s.DOMException = function(d, g) {
          this.message = d, this.name = g;
          var U = Error(d);
          this.stack = U.stack;
        }, s.DOMException.prototype = Object.create(Error.prototype), s.DOMException.prototype.constructor = s.DOMException;
      }
      function Ae(o, d) {
        return new Promise(function(g, U) {
          var E = new F(o, d);
          if (E.signal && E.signal.aborted)
            return U(new s.DOMException("Aborted", "AbortError"));
          var S = new XMLHttpRequest();
          function ae() {
            S.abort();
          }
          S.onload = function() {
            var V = {
              statusText: S.statusText,
              headers: le(S.getAllResponseHeaders() || "")
            };
            E.url.indexOf("file://") === 0 && (S.status < 200 || S.status > 599) ? V.status = 200 : V.status = S.status, V.url = "responseURL" in S ? S.responseURL : V.headers.get("X-Request-URL");
            var $ = "response" in S ? S.response : S.responseText;
            setTimeout(function() {
              g(new G($, V));
            }, 0);
          }, S.onerror = function() {
            setTimeout(function() {
              U(new TypeError("Network request failed"));
            }, 0);
          }, S.ontimeout = function() {
            setTimeout(function() {
              U(new TypeError("Network request timed out"));
            }, 0);
          }, S.onabort = function() {
            setTimeout(function() {
              U(new s.DOMException("Aborted", "AbortError"));
            }, 0);
          };
          function Re(V) {
            try {
              return V === "" && p.location.href ? p.location.href : V;
            } catch {
              return V;
            }
          }
          if (S.open(E.method, Re(E.url), !0), E.credentials === "include" ? S.withCredentials = !0 : E.credentials === "omit" && (S.withCredentials = !1), "responseType" in S && (r.blob ? S.responseType = "blob" : r.arrayBuffer && (S.responseType = "arraybuffer")), d && typeof d.headers == "object" && !(d.headers instanceof m || p.Headers && d.headers instanceof p.Headers)) {
            var Ve = [];
            Object.getOwnPropertyNames(d.headers).forEach(function(V) {
              Ve.push(L(V)), S.setRequestHeader(V, I(d.headers[V]));
            }), E.headers.forEach(function(V, $) {
              Ve.indexOf($) === -1 && S.setRequestHeader($, V);
            });
          } else
            E.headers.forEach(function(V, $) {
              S.setRequestHeader($, V);
            });
          E.signal && (E.signal.addEventListener("abort", ae), S.onreadystatechange = function() {
            S.readyState === 4 && E.signal.removeEventListener("abort", ae);
          }), S.send(typeof E._bodyInit > "u" ? null : E._bodyInit);
        });
      }
      return Ae.polyfill = !0, p.fetch || (p.fetch = Ae, p.Headers = m, p.Request = F, p.Response = G), s.Headers = m, s.Request = F, s.Response = G, s.fetch = Ae, Object.defineProperty(s, "__esModule", { value: !0 }), s;
    })({});
  })(i), i.fetch.ponyfill = !0, delete i.fetch.polyfill;
  var a = l.fetch ? l : i;
  n = a.fetch, n.default = a.fetch, n.fetch = a.fetch, n.Headers = a.Headers, n.Request = a.Request, n.Response = a.Response, e.exports = n;
})(De, De.exports);
var fe = De.exports;
const re = /* @__PURE__ */ sl(fe), ul = /* @__PURE__ */ pn({
  __proto__: null,
  default: re
}, [fe]), H = (e) => {
  let n = {};
  return e && (typeof Headers < "u" && e instanceof Headers || ul && fe.Headers && e instanceof fe.Headers ? n = mn(e) : Array.isArray(e) ? e.forEach(([l, i]) => {
    l && i !== void 0 && (n[l] = i);
  }) : n = e), n;
}, Me = (e) => e.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim(), pl = (e) => {
  if (!Array.isArray(e.query)) {
    const i = e, a = [`query=${encodeURIComponent(Me(i.query))}`];
    return e.variables && a.push(`variables=${encodeURIComponent(i.jsonSerializer.stringify(i.variables))}`), i.operationName && a.push(`operationName=${encodeURIComponent(i.operationName)}`), a.join("&");
  }
  if (typeof e.variables < "u" && !Array.isArray(e.variables))
    throw new Error("Cannot create query with given variable type, array expected");
  const n = e, l = e.query.reduce((i, a, t) => (i.push({
    query: Me(a),
    variables: n.variables ? n.jsonSerializer.stringify(n.variables[t]) : void 0
  }), i), []);
  return `query=${encodeURIComponent(n.jsonSerializer.stringify(l))}`;
}, dl = (e) => async (n) => {
  const { url: l, query: i, variables: a, operationName: t, fetch: s, fetchOptions: p, middleware: r } = n, N = { ...n.headers };
  let f = "", R;
  e === "POST" ? (R = cl(i, a, t, p.jsonSerializer), typeof R == "string" && (N["Content-Type"] = "application/json")) : f = pl({
    query: i,
    variables: a,
    operationName: t,
    jsonSerializer: p.jsonSerializer ?? Ee
  });
  const L = {
    method: e,
    headers: N,
    body: R,
    ...p
  };
  let I = l, A = L;
  if (r) {
    const m = await Promise.resolve(r({ ...L, url: l, operationName: t, variables: a })), { url: C, ...T } = m;
    I = C, A = T;
  }
  return f && (I = `${I}?${f}`), await s(I, A);
};
class rl {
  constructor(n, l = {}) {
    this.url = n, this.requestConfig = l, this.rawRequest = async (...i) => {
      const [a, t, s] = i, p = Tn(a, t, s), { headers: r, fetch: N = re, method: f = "POST", requestMiddleware: R, responseMiddleware: L, ...I } = this.requestConfig, { url: A } = this;
      p.signal !== void 0 && (I.signal = p.signal);
      const { operationName: m } = ge(p.query);
      return Oe({
        url: A,
        query: p.query,
        variables: p.variables,
        headers: {
          ...H(Ie(r)),
          ...H(p.requestHeaders)
        },
        operationName: m,
        fetch: N,
        method: f,
        fetchOptions: I,
        middleware: R
      }).then((C) => (L && L(C), C)).catch((C) => {
        throw L && L(C), C;
      });
    };
  }
  async request(n, ...l) {
    const [i, a] = l, t = yn(n, i, a), { headers: s, fetch: p = re, method: r = "POST", requestMiddleware: N, responseMiddleware: f, ...R } = this.requestConfig, { url: L } = this;
    t.signal !== void 0 && (R.signal = t.signal);
    const { query: I, operationName: A } = ge(t.document);
    return Oe({
      url: L,
      query: I,
      variables: t.variables,
      headers: {
        ...H(Ie(s)),
        ...H(t.requestHeaders)
      },
      operationName: A,
      fetch: p,
      method: r,
      fetchOptions: R,
      middleware: N
    }).then((m) => (f && f(m), m.data)).catch((m) => {
      throw f && f(m), m;
    });
  }
  // prettier-ignore
  batchRequests(n, l) {
    const i = Nn(n, l), { headers: a, ...t } = this.requestConfig;
    i.signal !== void 0 && (t.signal = i.signal);
    const s = i.documents.map(({ document: r }) => ge(r).query), p = i.documents.map(({ variables: r }) => r);
    return Oe({
      url: this.url,
      query: s,
      // @ts-expect-error TODO reconcile batch variables into system.
      variables: p,
      headers: {
        ...H(Ie(a)),
        ...H(i.requestHeaders)
      },
      operationName: void 0,
      fetch: this.requestConfig.fetch ?? re,
      method: this.requestConfig.method || "POST",
      fetchOptions: t,
      middleware: this.requestConfig.requestMiddleware
    }).then((r) => (this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(r), r.data)).catch((r) => {
      throw this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(r), r;
    });
  }
  setHeaders(n) {
    return this.requestConfig.headers = n, this;
  }
  /**
   * Attach a header to the client. All subsequent requests will have this header.
   */
  setHeader(n, l) {
    const { headers: i } = this.requestConfig;
    return i ? i[n] = l : this.requestConfig.headers = { [n]: l }, this;
  }
  /**
   * Change the client endpoint. All subsequent requests will send to this endpoint.
   */
  setEndpoint(n) {
    return this.url = n, this;
  }
}
const Oe = async (e) => {
  const { query: n, variables: l, fetchOptions: i } = e, a = dl(fn(e.method ?? "post")), t = Array.isArray(e.query), s = await a(e), p = await fl(s, i.jsonSerializer ?? Ee), r = Array.isArray(p) ? !p.some(({ data: f }) => !f) : !!p.data, N = Array.isArray(p) || !p.errors || Array.isArray(p.errors) && !p.errors.length || i.errorPolicy === "all" || i.errorPolicy === "ignore";
  if (s.ok && N && r) {
    const { errors: f, ...R } = (Array.isArray(p), p), L = i.errorPolicy === "ignore" ? R : p;
    return {
      ...t ? { data: L } : L,
      headers: s.headers,
      status: s.status
    };
  } else {
    const f = typeof p == "string" ? {
      error: p
    } : p;
    throw new K(
      // @ts-expect-error TODO
      { ...f, status: s.status, headers: s.headers },
      { query: n, variables: l }
    );
  }
}, cl = (e, n, l, i) => {
  const a = i ?? Ee;
  if (!Array.isArray(e))
    return a.stringify({ query: e, variables: n, operationName: l });
  if (typeof n < "u" && !Array.isArray(n))
    throw new Error("Cannot create request body with given variable type, array expected");
  const t = e.reduce((s, p, r) => (s.push({ query: p, variables: n ? n[r] : void 0 }), s), []);
  return a.stringify(t);
}, fl = async (e, n) => {
  let l;
  return e.headers.forEach((i, a) => {
    a.toLowerCase() === "content-type" && (l = i);
  }), l && (l.toLowerCase().startsWith("application/json") || l.toLowerCase().startsWith("application/graphql+json") || l.toLowerCase().startsWith("application/graphql-response+json")) ? n.parse(await e.text()) : e.text();
}, Ie = (e) => typeof e == "function" ? e() : e, Te = (e, ...n) => e.reduce((l, i, a) => `${l}${i}${a in n ? String(n[a]) : ""}`, ""), ml = {
  __schema: {
    queryType: {
      name: "Query"
    },
    mutationType: {
      name: "Mutation"
    },
    subscriptionType: null,
    types: [
      {
        kind: "OBJECT",
        name: "GqlAccount",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "externalId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "accountStatusId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "activatedAt",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "DateTime",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createdAt",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "DateTime",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "inviteCode",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "lastOnlineAt",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "DateTime",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "noSignUp",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "privacy",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "user",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlUser",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "positions",
            description: null,
            args: [
              {
                name: "treeId",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "ID",
                  ofType: null
                },
                defaultValue: null
              },
              {
                name: "positionId",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "ID",
                  ofType: null
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPosition"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "SCALAR",
        name: "Int",
        description: "The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.",
        fields: null,
        inputFields: null,
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "SCALAR",
        name: "String",
        description: "The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.",
        fields: null,
        inputFields: null,
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "SCALAR",
        name: "DateTime",
        description: "A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format.",
        fields: null,
        inputFields: null,
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "SCALAR",
        name: "Boolean",
        description: "The `Boolean` scalar type represents `true` or `false`.",
        fields: null,
        inputFields: null,
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "SCALAR",
        name: "ID",
        description: 'The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID.',
        fields: null,
        inputFields: null,
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlUser",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "accountId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "login",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "email",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isEmailConfirmed",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "phone",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isPhoneConfirmed",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "firstname",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "lastname",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "registeredAt",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "countryId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "regionId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "status",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isMain",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "languageId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "avatarId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "profile",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlProfileFieldData"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "aclRoles",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlAclRole"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "account",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAccount",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPosition",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "treeId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "accountId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "parentId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "startParentId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createdAt",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "DateTime",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "number",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "offset",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isActive",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isAlive",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isDeleted",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "spillLeg",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "treeLevel",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "account",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAccount",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "parent",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlPosition",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PaginationInfo",
        description: null,
        fields: [
          {
            name: "total",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "limit",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "page",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "EmptyGqlResponse",
        description: null,
        fields: [
          {
            name: "success",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "AccountPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlAccount"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlAclAdminRole",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "adminId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "aclRoleId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "admin",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAdmin",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "aclRole",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAclRole",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "AclAdminRolePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlAclAdminRole"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlAdmin",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "email",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isEmailConfirmed",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "firstname",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "lastname",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "registeredAt",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "DateTime",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "languageId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "phone",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isPhoneConfirmed",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "accountId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "passwordChangeAt",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "DateTime",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "status",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "roles",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlRole"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "aclRoles",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlAclRole"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlAclRole",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isSystem",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "alias",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "resources",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlAclRoleResource"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "AclRolePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlAclRole"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlAclRoleResource",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "aclRoleId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "resource",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "aclRole",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAclRole",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "AclRoleResourcePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlAclRoleResource"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlAclUserRole",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "userId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "aclRoleId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "aclRole",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAclRole",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "user",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlUser",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "AclUserRolePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlAclUserRole"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "AdminPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlAdmin"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlRole",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "name",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "alias",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlAdminRole",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "adminId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "roleId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "admin",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAdmin",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "role",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlRole",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "AdminRolePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlAdminRole"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlCountry",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "CountryPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlCountry"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlCurrency",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "ligatureDirection",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "ligature",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "CurrencyPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlCurrency"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlDictionary",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "alias",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isDeleted",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "dictionaryType",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "dictionaryItems",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlDictionaryItem"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "DictionaryPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlDictionary"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlDictionaryItem",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "dictionaryId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "key",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "priority",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isDeleted",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "value",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "dictionary",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlDictionary",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "DictionaryItemPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlDictionaryItem"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlDocType",
        description: null,
        fields: [
          {
            name: "name",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "description",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isAdmin",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isBatch",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "parameters",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "JSON",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "SCALAR",
        name: "JSON",
        description: "The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf).",
        fields: null,
        inputFields: null,
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "DocTypePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlDocType"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlFieldType",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "formatstr",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "alias",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "FieldTypePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlFieldType"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlLanguage",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "name",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isActive",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "LanguagePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlLanguage"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPlanProperty",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "planId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "fieldTypeId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "dictionaryId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isRank",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isVolume",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isInternalEditable",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isBonus",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isExternalEditable",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isDirectEditable",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "alias",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "treeId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "description",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isInvisible",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "order",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PlanPropertyPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPlanProperty"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2AccountPos",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "accountId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "account",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAccount",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "pos",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2Pos",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosAccountPosPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2AccountPos"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2Pos",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "countryId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "regionId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "accountId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isArchived",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "pickupAvailable",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "address",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "country",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlCountry",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "region",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlRegion",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "account",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlAccount",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2AdminPos",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "adminId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "admin",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAdmin",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "pos",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2Pos",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosAdminPosPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2AdminPos"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2CatalogCategory",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "parentId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "description",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isArchived",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isRestricted",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosCatalogCategoryPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CatalogCategory"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2CatalogCategoryRank",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "categoryId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "rankPlanPropertyId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "rank",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "catalogCategory",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogCategory",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "rankPlanProperty",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPlanProperty",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosCatalogCategoryRankPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CatalogCategoryRank"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2CatalogItem",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "description",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isArchived",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "article",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "unit",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "categories",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CatalogCategory"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "prices",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CatalogItemPrice"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "images",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CatalogItemImage"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "remains",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CatalogItemRemain"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "volumes",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CatalogItemVolume"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosCatalogItemPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CatalogItem"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2CatalogItemPrice",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "catalogItemId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "priceListId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "price",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "catalogItem",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogItem",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "priceList",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2PriceList",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "SCALAR",
        name: "Float",
        description: "The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point).",
        fields: null,
        inputFields: null,
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2CatalogItemImage",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "catalogItemId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "fileStorageId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "image",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlImageData",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2CatalogItemRemain",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "catalogItemId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "income",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "outcome",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "both",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "reserved",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "available",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "inStock",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "catalogItem",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogItem",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "pos",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2Pos",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2CatalogItemVolume",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "catalogItemId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "volumePropertyId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "amount",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "catalogItem",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogItem",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "volumeProperty",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2VolumeProperty",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2CatalogItemCategory",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "catalogItemId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "catalogCategoryId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosCatalogItemCategoryPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CatalogItemCategory"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2CatalogItemDocument",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "catalogItemId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "quantity",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "price",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "discount",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Float",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "volumes",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "JSON",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "catalogItem",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogItem",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "document",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2Document",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosCatalogItemDocumentPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CatalogItemDocument"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2Document",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "number",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "offset",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "sourcePosId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "targetPosId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "sourceDocumentId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createdAt",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "DateTime",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "creatorAdminId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "periodId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "accountId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isArchived",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentTypeId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentStatusId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "notice",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "properties",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "JSON",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isPaid",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isVolumeSent",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "currencyId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "totalItemQuantity",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "totalItemPrice",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paidTotal",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paidTotalFromWallet",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "totalItemDiscount",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isFulfilled",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "fulfilledItemsCount",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "sourcePos",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlPos2Pos",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "targetPos",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlPos2Pos",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentType",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentType",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentStatus",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentStatus",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "currency",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlCurrency",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "account",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlAccount",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "creatorAdmin",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAdmin",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "sourceDocument",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlPos2Document",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosCatalogItemImagePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CatalogItemImage"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlImageData",
        description: null,
        fields: [
          {
            name: "thumbUrl",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "imageUrl",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosCatalogItemPricePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CatalogItemPrice"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2PriceList",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "type",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isArchived",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "currencyId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosCatalogItemRemainPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CatalogItemRemain"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosCatalogItemVolumePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CatalogItemVolume"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2VolumeProperty",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "alias",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isMain",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "type",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "ENUM",
                name: "Pos2VolumePropertyTypes",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "ENUM",
        name: "Pos2VolumePropertyTypes",
        description: null,
        fields: null,
        inputFields: null,
        interfaces: null,
        enumValues: [
          {
            name: "Volume",
            description: null,
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "Status",
            description: null,
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2CpDocumentSendConfig",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentName",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "sendLimit",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosCpDocumentSendConfigPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CpDocumentSendConfig"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2CpDocumentSendLog",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "timestamp",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "DateTime",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "cpDocumentSendConfigId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "cpDocumentGuid",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "cpDocumentSendConfig",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CpDocumentSendConfig",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "document",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2Document",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosCpDocumentSendLogPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CpDocumentSendLog"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2DocumentByPk",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "number",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "offset",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "sourcePosId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "targetPosId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "sourceDocumentId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createdAt",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "DateTime",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "creatorAdminId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "periodId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "accountId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isArchived",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentTypeId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentStatusId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "notice",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "properties",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "JSON",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isPaid",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isVolumeSent",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "currencyId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "totalItemQuantity",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "totalItemPrice",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paidTotal",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paidTotalFromWallet",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "totalItemDiscount",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isFulfilled",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "fulfilledItemsCount",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "sourcePos",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlPos2Pos",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "targetPos",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlPos2Pos",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentType",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentType",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentStatus",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentStatus",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "currency",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlCurrency",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "account",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlAccount",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "creatorAdmin",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAdmin",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "sourceDocument",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlPos2Document",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "catalogItemDocument",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2CatalogItemDocument"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosDocumentPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2Document"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2DocumentType",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "direction",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isDeleted",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "format",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2DocumentStatus",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentTypeId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isArchived",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isInitial",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isForVolumeTransfer",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "status",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "color",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isPaid",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isEditable",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentSendConfigId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "alias",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentType",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentType",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "cpDocumentSendConfig",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlPos2CpDocumentSendConfig",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2DocumentLog",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "adminId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "prevDocumentStatusId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "nextDocumentStatusId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "admin",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAdmin",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "prevDocumentStatus",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentStatus",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "nextDocumentStatus",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentStatus",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "document",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2Document",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosDocumentLogPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2DocumentLog"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2DocumentProperty",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "description",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "alias",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "fieldTypeId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "dictionaryId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "required",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentTypeId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "fieldType",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlFieldType",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "dictionary",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlDictionary",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentType",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentType",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosDocumentPropertyPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2DocumentProperty"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosDocumentStatusPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2DocumentStatus"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2DocumentStatusRule",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "prevDocumentStatusId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "nextDocumentStatusId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "prevDocumentStatus",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentStatus",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "nextDocumentStatus",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentStatus",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosDocumentStatusRulePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2DocumentStatusRule"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosDocumentTypePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2DocumentType"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2Payment",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createdAt",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "DateTime",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "accountId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "documentId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paymentTypeId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "amount",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "notice",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "account",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAccount",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "document",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2Document",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "pos",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2Pos",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paymentType",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2PaymentType",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosPaymentPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2Payment"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2PaymentType",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "walletTypeId",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paymentSumLimit",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "walletType",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "GqlWalletType",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosPaymentTypePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2PaymentType"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlWalletType",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "currencyId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isActive",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "alias",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosPosPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2Pos"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlRegion",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "countryId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "country",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlCountry",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosPriceListPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2PriceList"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlPos2PriceListRank",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "priceListId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "rankPlanPropertyId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "rank",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "priceList",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2PriceList",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "rankPlanProperty",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPlanProperty",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosPriceListRankPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2PriceListRank"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "PosVolumePropertyPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPos2VolumeProperty"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlProfileField",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "title",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "description",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "fieldTypeId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "dictionaryId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isMandatory",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "alias",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isSystem",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "fieldType",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlFieldType",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "GqlProfileFieldData",
        description: null,
        fields: [
          {
            name: "id",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "userId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "value",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "profileFieldId",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isDeleted",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "profileField",
            description: null,
            args: [
              {
                name: "includeDeleted",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Boolean",
                  ofType: null
                },
                defaultValue: "true"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlProfileField",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "RegionPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlRegion"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "RolePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlRole"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "UserPaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlUser"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "WalletTypePaginated",
        description: null,
        fields: [
          {
            name: "list",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlWalletType"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "paginationInfo",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PaginationInfo",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "Query",
        description: null,
        fields: [
          {
            name: "walletType",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "WalletTypePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "user",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "UserPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "role",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "RolePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "region",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "RegionPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "profileFields",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlProfileField"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posVolumeProperty",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosVolumePropertyPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posPriceListRank",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosPriceListRankPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posPriceList",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosPriceListPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posPos",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosPosPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posPaymentType",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosPaymentTypePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posPayment",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosPaymentPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posDocumentType",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosDocumentTypePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posDocumentStatusRule",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosDocumentStatusRulePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posDocumentStatus",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosDocumentStatusPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posDocumentProperty",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosDocumentPropertyPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posDocumentLog",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosDocumentLogPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posDocumentByPk",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentByPk",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posDocument",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosDocumentPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "accountPosDocument",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "AccountPosDocumentGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosDocumentPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posCpDocumentSendLog",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosCpDocumentSendLogPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posCpDocumentSendConfig",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosCpDocumentSendConfigPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posCatalogItemVolume",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosCatalogItemVolumePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posCatalogItemRemain",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosCatalogItemRemainPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posCatalogItemPrice",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosCatalogItemPricePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posCatalogItemImage",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosCatalogItemImagePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posCatalogItemDocument",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosCatalogItemDocumentPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posCatalogItemCategory",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosCatalogItemCategoryPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posCatalogItem",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosCatalogItemPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posCatalogCategoryRank",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosCatalogCategoryRankPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posCatalogCategory",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosCatalogCategoryPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posAdminPos",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosAdminPosPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "posAccountPos",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PosAccountPosPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "planProperty",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "PlanPropertyPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "language",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "LanguagePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "fieldType",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "FieldTypePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "downline",
            description: null,
            args: [
              {
                name: "positionId",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "ID",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "GqlPosition"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "docType",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "DocTypePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "dictionaryItem",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "DictionaryItemPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "dictionary",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "DictionaryPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "currency",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "CurrencyPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "country",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "CountryPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "adminRole",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "AdminRolePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "admin",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "AdminPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "currentAdmin",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAdmin",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "aclUserRole",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "AclUserRolePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "aclRoleResource",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "AclRoleResourcePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "aclRole",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "AclRolePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "currentAclRole",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "AclRolePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "aclAdminRole",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "AclAdminRolePaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "account",
            description: null,
            args: [
              {
                name: "page",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "0"
              },
              {
                name: "limit",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Int",
                  ofType: null
                },
                defaultValue: "10"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "AccountPaginated",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "currentAccount",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAccount",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "AccountPosDocumentGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "accountId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "Mutation",
        description: null,
        fields: [
          {
            name: "createWalletType",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "WalletTypeCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlWalletType",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updateWalletType",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "WalletTypeUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlWalletType",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deleteWalletType",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updateUserAclRoles",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "UserUpdateAclRolesGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Float",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlUser",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createRegion",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "RegionCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlRegion",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updateRegion",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "RegionUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlRegion",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deleteRegion",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosVolumeProperty",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosVolumePropertyCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2VolumeProperty",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosVolumeProperty",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosVolumePropertyUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2VolumeProperty",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosVolumeProperty",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosPriceListRank",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosPriceListRankCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2PriceListRank",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosPriceListRank",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosPriceListRankUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2PriceListRank",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosPriceListRank",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosPriceList",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosPriceListCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2PriceList",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosPriceList",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosPriceListUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2PriceList",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosPriceList",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosPos",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosPosCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2Pos",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosPos",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosPosUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2Pos",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosPos",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosPaymentType",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosPaymentTypeCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2PaymentType",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosPaymentType",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosPaymentTypeUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2PaymentType",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosPaymentType",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosPayment",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosPayment",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosPaymentCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2Payment",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosDocumentType",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosDocumentTypeUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentType",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosDocumentStatusRule",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosDocumentStatusRuleCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentStatusRule",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosDocumentStatusRule",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosDocumentStatusRuleUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentStatusRule",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosDocumentStatusRule",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosDocumentStatus",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosDocumentStatusCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentStatus",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosDocumentStatus",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosDocumentStatusUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentStatus",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosDocumentStatus",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosDocumentProperty",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosDocumentPropertyCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentProperty",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosDocumentProperty",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosDocumentPropertyUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2DocumentProperty",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosDocumentProperty",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosDocumentLog",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosDocument",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosDocumentCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2Document",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "setPosDocumentStatus",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosDocumentSetStatusGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2Document",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "setPosDocumentAccount",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosDocumentSetAccountGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Float",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2Document",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosDocument",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosDocumentUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2Document",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosCpDocumentSendConfig",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCpDocumentSendConfigCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CpDocumentSendConfig",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosCpDocumentSendConfig",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCpDocumentSendConfigUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CpDocumentSendConfig",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosCpDocumentSendConfig",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosCatalogItemVolume",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCatalogItemVolumeCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogItemVolume",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosCatalogItemVolume",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCatalogItemVolumeUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogItemVolume",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosCatalogItemVolume",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosCatalogItemRemain",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosCatalogItemPrice",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCatalogItemPriceCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogItemPrice",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosCatalogItemPrice",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCatalogItemPriceUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogItemPrice",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosCatalogItemPrice",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosCatalogItemImage",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCatalogItemImageCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogItemImage",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosCatalogItemImage",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosCatalogItemDocument",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCatalogItemDocumentCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogItemDocument",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosCatalogItemDocument",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCatalogItemDocumentUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogItemDocument",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosCatalogItemDocument",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosCatalogItemCategory",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCatalogItemCategoryCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogItemCategory",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosCatalogItemCategory",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCatalogItemCategoryUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogItemCategory",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosCatalogItemCategory",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosCatalogItem",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCatalogItemCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogItem",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosCatalogItem",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCatalogItemUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogItem",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosCatalogItem",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosCatalogCategoryRank",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCatalogCategoryRankCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogCategoryRank",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosCatalogCategoryRank",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCatalogCategoryRankUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogCategoryRank",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosCatalogCategoryRank",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosCatalogCategory",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCatalogCategoryCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogCategory",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePosCatalogCategory",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosCatalogCategoryUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2CatalogCategory",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosCatalogCategory",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosAdminPos",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosAdminPos",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosAdminPosCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2AdminPos",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createPosAccountPos",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PosAccountPosCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPos2AccountPos",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deletePosAccountPos",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updatePlanProperty",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "PlanPropertyUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlPlanProperty",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createLanguage",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "LanguageCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlLanguage",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updateLanguage",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "LanguageUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "String",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlLanguage",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deleteLanguage",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "String",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createDictionaryItem",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "DictionaryItemCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlDictionaryItem",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updateDictionaryItem",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "DictionaryItemUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlDictionaryItem",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deleteDictionaryItem",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createDictionary",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "DictionaryCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlDictionary",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updateDictionary",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "DictionaryUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlDictionary",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deleteDictionary",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createCurrency",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "CurrencyCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlCurrency",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updateCurrency",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "CurrencyUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlCurrency",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deleteCurrency",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createCountry",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "CountryCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlCountry",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updateCountry",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "CountryUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlCountry",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deleteCountry",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deleteAdminRole",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createAdminRole",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "AdminRoleCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAdminRole",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deleteAdmin",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createAdmin",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "AdminCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAdmin",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updateAdmin",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "AdminUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAdmin",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deleteAclUserRole",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createAclUserRole",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "AclUserRoleCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAclUserRole",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updateAclRoleResource",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "AclRoleResourceUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAclRoleResource",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deleteAclRoleResource",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createAclRoleResource",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "AclRoleResourceCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAclRoleResource",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createAclRole",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "AclRoleCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAclRole",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "updateAclRole",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "AclRoleUpdateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              },
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAclRole",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deleteAclRole",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deleteAclAdminRole",
            description: null,
            args: [
              {
                name: "id",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "EmptyGqlResponse",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "createAclAdminRole",
            description: null,
            args: [
              {
                name: "input",
                description: null,
                type: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "INPUT_OBJECT",
                    name: "AclAdminRoleCreateGqlInput",
                    ofType: null
                  }
                },
                defaultValue: null
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "GqlAclAdminRole",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "WalletTypeCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "currencyId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "isActive",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "alias",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "WalletTypeUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "currencyId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isActive",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "alias",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "UserUpdateAclRolesGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "aclRoleIds",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "SCALAR",
                    name: "Int"
                  }
                }
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "RegionCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "countryId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "code",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "RegionUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "countryId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "code",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosVolumePropertyCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "alias",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "isMain",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "type",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "ENUM",
                name: "Pos2VolumePropertyTypes",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosVolumePropertyUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "isMain",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "alias",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "type",
            description: null,
            type: {
              kind: "ENUM",
              name: "Pos2VolumePropertyTypes",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosPriceListRankCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "priceListId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "rankPlanPropertyId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "rank",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosPriceListRankUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "priceListId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "rankPlanPropertyId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "rank",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosPriceListCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "type",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "currencyId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosPriceListUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "type",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "currencyId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosPosCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "countryId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "regionId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "pickupAvailable",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "address",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "accountId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosPosUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "countryId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "title",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "regionId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "accountId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "pickupAvailable",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosPaymentTypeCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "walletTypeId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "paymentSumLimit",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosPaymentTypeUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "walletTypeId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "paymentSumLimit",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosPaymentCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "accountId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "documentId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "posId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "paymentTypeId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "amount",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "notice",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosDocumentTypeUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "format",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosDocumentStatusRuleCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "prevDocumentStatusId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "nextDocumentStatusId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosDocumentStatusRuleUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "prevDocumentStatusId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "nextDocumentStatusId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosDocumentStatusCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "documentTypeId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "isArchived",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isInitial",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "isForVolumeTransfer",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "status",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "color",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "isPaid",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "documentSendConfigId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "alias",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosDocumentStatusUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "documentTypeId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isArchived",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isInitial",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isForVolumeTransfer",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "status",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "color",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isPaid",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "documentSendConfigId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosDocumentPropertyCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "description",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "alias",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "fieldTypeId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "dictionaryId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "required",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "documentTypeId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosDocumentPropertyUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "description",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "alias",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "fieldTypeId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "dictionaryId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "required",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosDocumentCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "sourcePosId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "targetPosId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "sourceDocumentId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "accountId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "documentTypeId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "documentStatusId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "currencyId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "notice",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "properties",
            description: null,
            type: {
              kind: "SCALAR",
              name: "JSON",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "documentItems",
            description: null,
            type: {
              kind: "LIST",
              name: null,
              ofType: {
                kind: "NON_NULL",
                name: null,
                ofType: {
                  kind: "INPUT_OBJECT",
                  name: "GqlPosDocumentItem",
                  ofType: null
                }
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "GqlPosDocumentItem",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "catalogItemId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "quantity",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "price",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "discount",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Float",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "volumes",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "JSON",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosDocumentSetStatusGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "statusId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosDocumentSetAccountGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "accountId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosDocumentUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "isArchived",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "notice",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "properties",
            description: null,
            type: {
              kind: "SCALAR",
              name: "JSON",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCpDocumentSendConfigCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "documentName",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "sendLimit",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCpDocumentSendConfigUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "documentName",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "sendLimit",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCatalogItemVolumeCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "catalogItemId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "volumePropertyId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "amount",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCatalogItemVolumeUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "amount",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCatalogItemPriceCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "catalogItemId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "priceListId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "price",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCatalogItemPriceUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "catalogItemId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "priceListId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "price",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Float",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCatalogItemImageCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "catalogItemId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "imageData",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "INPUT_OBJECT",
                name: "GqlImageDataInput",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "GqlImageDataInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "fileData",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "fileName",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCatalogItemDocumentCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "catalogItemId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "documentId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "quantity",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "price",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "discount",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "volumes",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "JSON",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCatalogItemDocumentUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "quantity",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "price",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "discount",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Float",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "volumes",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "JSON",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCatalogItemCategoryCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "catalogItemId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "catalogCategoryId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCatalogItemCategoryUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "catalogItemId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "catalogCategoryId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCatalogItemCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "description",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "article",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "unit",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCatalogItemUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "description",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "article",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "unit",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCatalogCategoryRankCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "catalogCategoryId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "rankPlanPropertyId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "rank",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCatalogCategoryRankUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "rank",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCatalogCategoryCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "parentId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "description",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosCatalogCategoryUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "parentId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "title",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "description",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isArchived",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isRestricted",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosAdminPosCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "adminId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "posId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PosAccountPosCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "accountId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "posId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "PlanPropertyUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isInternalEditable",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isExternalEditable",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isDirectEditable",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isInvisible",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "description",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "order",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "LanguageCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "id",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "name",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "isActive",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "LanguageUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "name",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isActive",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "DictionaryItemCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "dictionaryId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "key",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "value",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "DictionaryItemUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "dictionaryId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "key",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "value",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "DictionaryCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "alias",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "dictionaryType",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "DictionaryUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "alias",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "dictionaryType",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "CurrencyCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "ligatureDirection",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "ligature",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "CurrencyUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "ligatureDirection",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "ligature",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "CountryCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "id",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "CountryUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "AdminRoleCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "adminId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "roleId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "AdminCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "email",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "isEmailConfirmed",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "firstname",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "lastname",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "languageId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "phone",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isPhoneConfirmed",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "accountId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "password",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "AdminUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "email",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isEmailConfirmed",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "firstname",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "lastname",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "languageId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "phone",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "isPhoneConfirmed",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Boolean",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "accountId",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "password",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "AclUserRoleCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "userId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "aclRoleId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "AclRoleResourceUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "resource",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "AclRoleResourceCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "aclRoleId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "resource",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "AclRoleCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "alias",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "AclRoleUpdateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "title",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "alias",
            description: null,
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "AclAdminRoleCreateGqlInput",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "adminId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          },
          {
            name: "aclRoleId",
            description: null,
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Int",
                ofType: null
              }
            },
            defaultValue: null
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "INPUT_OBJECT",
        name: "FilterInputTypeDefinition",
        description: null,
        fields: null,
        inputFields: [
          {
            name: "operation",
            description: null,
            type: {
              kind: "ENUM",
              name: "FilterOperationsTypeDefinition",
              ofType: null
            },
            defaultValue: null
          },
          {
            name: "value",
            description: null,
            type: {
              kind: "SCALAR",
              name: "FilterValue",
              ofType: null
            },
            defaultValue: "null"
          },
          {
            name: "values",
            description: null,
            type: {
              kind: "LIST",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "FilterValue",
                ofType: null
              }
            },
            defaultValue: "null"
          },
          {
            name: "mode",
            description: null,
            type: {
              kind: "ENUM",
              name: "FilterModeTypeDefinition",
              ofType: null
            },
            defaultValue: "AND"
          }
        ],
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "ENUM",
        name: "FilterOperationsTypeDefinition",
        description: null,
        fields: null,
        inputFields: null,
        interfaces: null,
        enumValues: [
          {
            name: "EQ",
            description: "=",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "N_EQ",
            description: "!=",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "GT",
            description: ">",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "GTE",
            description: ">=",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "LT",
            description: "<",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "LTE",
            description: "<=",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "IN",
            description: "In",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "NOT_IN",
            description: "Not in",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "LIKE",
            description: "Like case sensitive",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "I_LIKE",
            description: "Like case insensitive",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "NOT_LIKE",
            description: "Not like case sensitive",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "NOT_I_LIKE",
            description: "Not like case insensitive",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "BETWEEN",
            description: "Between",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "NOT_BETWEEN",
            description: "Not between",
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        possibleTypes: null
      },
      {
        kind: "SCALAR",
        name: "FilterValue",
        description: "Value to filter",
        fields: null,
        inputFields: null,
        interfaces: null,
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "ENUM",
        name: "FilterModeTypeDefinition",
        description: null,
        fields: null,
        inputFields: null,
        interfaces: null,
        enumValues: [
          {
            name: "AND",
            description: "And",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "OR",
            description: "Or",
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        possibleTypes: null
      },
      {
        kind: "ENUM",
        name: "OrderByDirectionDefinition",
        description: null,
        fields: null,
        inputFields: null,
        interfaces: null,
        enumValues: [
          {
            name: "ASC",
            description: null,
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "DESC",
            description: null,
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "__Schema",
        description: "A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations.",
        fields: [
          {
            name: "description",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "types",
            description: "A list of all types supported by this server.",
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "__Type"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "queryType",
            description: "The type that query operations will be rooted at.",
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "__Type",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "mutationType",
            description: "If this server supports mutation, the type that mutation operations will be rooted at.",
            args: [],
            type: {
              kind: "OBJECT",
              name: "__Type",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "subscriptionType",
            description: "If this server support subscription, the type that subscription operations will be rooted at.",
            args: [],
            type: {
              kind: "OBJECT",
              name: "__Type",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "directives",
            description: "A list of all directives supported by this server.",
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "__Directive"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "__Type",
        description: "The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.\n\nDepending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.",
        fields: [
          {
            name: "kind",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "ENUM",
                name: "__TypeKind",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "name",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "description",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "specifiedByURL",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "fields",
            description: null,
            args: [
              {
                name: "includeDeprecated",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Boolean",
                  ofType: null
                },
                defaultValue: "false"
              }
            ],
            type: {
              kind: "LIST",
              name: null,
              ofType: {
                kind: "NON_NULL",
                name: null,
                ofType: {
                  kind: "OBJECT",
                  name: "__Field",
                  ofType: null
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "interfaces",
            description: null,
            args: [],
            type: {
              kind: "LIST",
              name: null,
              ofType: {
                kind: "NON_NULL",
                name: null,
                ofType: {
                  kind: "OBJECT",
                  name: "__Type",
                  ofType: null
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "possibleTypes",
            description: null,
            args: [],
            type: {
              kind: "LIST",
              name: null,
              ofType: {
                kind: "NON_NULL",
                name: null,
                ofType: {
                  kind: "OBJECT",
                  name: "__Type",
                  ofType: null
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "enumValues",
            description: null,
            args: [
              {
                name: "includeDeprecated",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Boolean",
                  ofType: null
                },
                defaultValue: "false"
              }
            ],
            type: {
              kind: "LIST",
              name: null,
              ofType: {
                kind: "NON_NULL",
                name: null,
                ofType: {
                  kind: "OBJECT",
                  name: "__EnumValue",
                  ofType: null
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "inputFields",
            description: null,
            args: [
              {
                name: "includeDeprecated",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Boolean",
                  ofType: null
                },
                defaultValue: "false"
              }
            ],
            type: {
              kind: "LIST",
              name: null,
              ofType: {
                kind: "NON_NULL",
                name: null,
                ofType: {
                  kind: "OBJECT",
                  name: "__InputValue",
                  ofType: null
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "ofType",
            description: null,
            args: [],
            type: {
              kind: "OBJECT",
              name: "__Type",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "ENUM",
        name: "__TypeKind",
        description: "An enum describing what kind of type a given `__Type` is.",
        fields: null,
        inputFields: null,
        interfaces: null,
        enumValues: [
          {
            name: "SCALAR",
            description: "Indicates this type is a scalar.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "OBJECT",
            description: "Indicates this type is an object. `fields` and `interfaces` are valid fields.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "INTERFACE",
            description: "Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "UNION",
            description: "Indicates this type is a union. `possibleTypes` is a valid field.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "ENUM",
            description: "Indicates this type is an enum. `enumValues` is a valid field.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "INPUT_OBJECT",
            description: "Indicates this type is an input object. `inputFields` is a valid field.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "LIST",
            description: "Indicates this type is a list. `ofType` is a valid field.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "NON_NULL",
            description: "Indicates this type is a non-null. `ofType` is a valid field.",
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "__Field",
        description: "Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type.",
        fields: [
          {
            name: "name",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "description",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "args",
            description: null,
            args: [
              {
                name: "includeDeprecated",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Boolean",
                  ofType: null
                },
                defaultValue: "false"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "__InputValue"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "type",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "__Type",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isDeprecated",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deprecationReason",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "__InputValue",
        description: "Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value.",
        fields: [
          {
            name: "name",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "description",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "type",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "OBJECT",
                name: "__Type",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "defaultValue",
            description: "A GraphQL-formatted string representing the default value for this input value.",
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isDeprecated",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deprecationReason",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "__EnumValue",
        description: "One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string.",
        fields: [
          {
            name: "name",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "description",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isDeprecated",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "deprecationReason",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "OBJECT",
        name: "__Directive",
        description: `A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.

In some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.`,
        fields: [
          {
            name: "name",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "description",
            description: null,
            args: [],
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "isRepeatable",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "locations",
            description: null,
            args: [],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "ENUM",
                    name: "__DirectiveLocation"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "args",
            description: null,
            args: [
              {
                name: "includeDeprecated",
                description: null,
                type: {
                  kind: "SCALAR",
                  name: "Boolean",
                  ofType: null
                },
                defaultValue: "false"
              }
            ],
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "LIST",
                name: null,
                ofType: {
                  kind: "NON_NULL",
                  name: null,
                  ofType: {
                    kind: "OBJECT",
                    name: "__InputValue"
                  }
                }
              }
            },
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        inputFields: null,
        interfaces: [],
        enumValues: null,
        possibleTypes: null
      },
      {
        kind: "ENUM",
        name: "__DirectiveLocation",
        description: "A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.",
        fields: null,
        inputFields: null,
        interfaces: null,
        enumValues: [
          {
            name: "QUERY",
            description: "Location adjacent to a query operation.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "MUTATION",
            description: "Location adjacent to a mutation operation.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "SUBSCRIPTION",
            description: "Location adjacent to a subscription operation.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "FIELD",
            description: "Location adjacent to a field.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "FRAGMENT_DEFINITION",
            description: "Location adjacent to a fragment definition.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "FRAGMENT_SPREAD",
            description: "Location adjacent to a fragment spread.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "INLINE_FRAGMENT",
            description: "Location adjacent to an inline fragment.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "VARIABLE_DEFINITION",
            description: "Location adjacent to a variable definition.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "SCHEMA",
            description: "Location adjacent to a schema definition.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "SCALAR",
            description: "Location adjacent to a scalar definition.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "OBJECT",
            description: "Location adjacent to an object type definition.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "FIELD_DEFINITION",
            description: "Location adjacent to a field definition.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "ARGUMENT_DEFINITION",
            description: "Location adjacent to an argument definition.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "INTERFACE",
            description: "Location adjacent to an interface definition.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "UNION",
            description: "Location adjacent to a union definition.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "ENUM",
            description: "Location adjacent to an enum definition.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "ENUM_VALUE",
            description: "Location adjacent to an enum value definition.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "INPUT_OBJECT",
            description: "Location adjacent to an input object type definition.",
            isDeprecated: !1,
            deprecationReason: null
          },
          {
            name: "INPUT_FIELD_DEFINITION",
            description: "Location adjacent to an input object field definition.",
            isDeprecated: !1,
            deprecationReason: null
          }
        ],
        possibleTypes: null
      }
    ],
    directives: [
      {
        name: "include",
        description: "Directs the executor to include this field or fragment only when the `if` argument is true.",
        locations: [
          "FIELD",
          "FRAGMENT_SPREAD",
          "INLINE_FRAGMENT"
        ],
        args: [
          {
            name: "if",
            description: "Included when true.",
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            defaultValue: null
          }
        ]
      },
      {
        name: "skip",
        description: "Directs the executor to skip this field or fragment when the `if` argument is true.",
        locations: [
          "FIELD",
          "FRAGMENT_SPREAD",
          "INLINE_FRAGMENT"
        ],
        args: [
          {
            name: "if",
            description: "Skipped when true.",
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "Boolean",
                ofType: null
              }
            },
            defaultValue: null
          }
        ]
      },
      {
        name: "deprecated",
        description: "Marks an element of a GraphQL schema as no longer supported.",
        locations: [
          "FIELD_DEFINITION",
          "ARGUMENT_DEFINITION",
          "INPUT_FIELD_DEFINITION",
          "ENUM_VALUE"
        ],
        args: [
          {
            name: "reason",
            description: "Explains why this element was deprecated, usually also including a suggestion for how to access supported similar data. Formatted using the Markdown syntax, as specified by [CommonMark](https://commonmark.org/).",
            type: {
              kind: "SCALAR",
              name: "String",
              ofType: null
            },
            defaultValue: '"No longer supported"'
          }
        ]
      },
      {
        name: "specifiedBy",
        description: "Exposes a URL that specifies the behavior of this scalar.",
        locations: [
          "SCALAR"
        ],
        args: [
          {
            name: "url",
            description: "The URL that specifies the behavior of this scalar.",
            type: {
              kind: "NON_NULL",
              name: null,
              ofType: {
                kind: "SCALAR",
                name: "String",
                ofType: null
              }
            },
            defaultValue: null
          }
        ]
      },
      {
        name: "filters",
        description: null,
        locations: [
          "FIELD"
        ],
        args: [
          {
            name: "items",
            description: null,
            type: {
              kind: "LIST",
              name: null,
              ofType: {
                kind: "INPUT_OBJECT",
                name: "FilterInputTypeDefinition",
                ofType: null
              }
            },
            defaultValue: null
          }
        ]
      },
      {
        name: "orderBy",
        description: null,
        locations: [
          "FIELD"
        ],
        args: [
          {
            name: "direction",
            description: null,
            type: {
              kind: "ENUM",
              name: "OrderByDirectionDefinition",
              ofType: null
            },
            defaultValue: "ASC"
          },
          {
            name: "index",
            description: null,
            type: {
              kind: "SCALAR",
              name: "Int",
              ofType: null
            },
            defaultValue: "0"
          }
        ]
      }
    ]
  }
}, nn = {
  data: ml
};
function yl(e) {
  const n = [];
  let l = e, i = !1;
  for (; l; ) {
    if (l.kind === "NON_NULL") {
      i = !0, l = l.ofType;
      continue;
    }
    const a = {
      nonNull: i,
      name: l.name || void 0,
      kind: l.kind
    };
    n.push(a), l = l.ofType;
  }
  return n;
}
function _l() {
  return nn;
}
function M(e, n = "fields", l = "", i) {
  var N;
  const a = nn.data.__schema.types;
  function t(f) {
    return (i || []).filter((R) => R === f).length;
  }
  if (i && t(e) > 1)
    return [];
  i = [...i || [], e];
  const s = a.find((f) => f.name === e);
  if (!s)
    return [];
  const p = ((N = s == null ? void 0 : s[n]) == null ? void 0 : N.flatMap((f) => r(f.name, f.type, l || `${Le(e)}.`))) || [];
  function r(f, R, L = "") {
    const I = yl(R);
    if (I.length === 0)
      throw new Error("No types found");
    const A = I[0];
    if (A.kind === "SCALAR")
      return {
        fullName: `${L}${f}`,
        nonNull: A.nonNull,
        name: f,
        type: A.name,
        memberOf: e
      };
    if (A.kind === "ENUM")
      return {
        fullName: `${L}${f}`,
        nonNull: A.nonNull,
        name: f,
        type: "Enum",
        memberOf: e
      };
    if (A.kind.endsWith("OBJECT")) {
      const m = `${L}${f}.`;
      if (!A.name)
        throw new Error("No nextRoot found");
      return M(A.name, n, m, i);
    }
    if (A.kind === "LIST") {
      const m = `${L}${f}[].`, C = "", T = I[1], _ = T.name;
      if (!_)
        throw new Error("No nextRoot found");
      return ["SCALAR"].includes(T.kind) ? {
        name: f,
        fullName: `${m}${_}${C}`,
        type: T.name
      } : M(_, n, m, i);
    }
    return [];
  }
  return p;
}
function Sl(e) {
  const n = M(ln(e), "inputFields");
  if (n != null && n.length)
    return n;
}
function Ul(e) {
  const n = M(an(e), "inputFields");
  if (n != null && n.length)
    return n;
}
function Tl(e) {
  const n = M(Ne(e));
  if (n != null && n.length)
    return n;
}
function Dl(e, n) {
  return e.filter((l) => n.includes(l.fullName));
}
function ln(e) {
  return `${e.replace("Paginated", "").replace(/^Gql/, "")}CreateGqlInput`;
}
function an(e) {
  return `${e.replace("Paginated", "").replace(/^Gql/, "")}UpdateGqlInput`;
}
function Ne(e) {
  let n = e.replace("Paginated", "");
  return n.startsWith("Gql") || (n = `Gql${n}`), n.includes("GqlPos") && (n.includes("GqlPos2") || (n = n.replace("GqlPos", "GqlPos2"))), n;
}
function Be(e) {
  return e.replace(/^Gql/, "").replace(/Paginated$/, "").replace("CreateGqlInput", "").replace("UpdateGqlInput", "").replace("Pos2", "Pos");
}
function Le(e) {
  const n = Be(e);
  return n[0].toLowerCase() + n.substring(1);
}
function El(e) {
  return Be(e).replace(/^Pos2?/, "").replace(/([A-Z])/g, " $1").trim();
}
function hl(e) {
  const n = Be(e);
  return Nl(n.replace(/^Pos2?/, ""));
}
function Nl(e) {
  return e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function Pl(e) {
  return e.memberOf ? `model_${Le(e.memberOf)}.${e.name}` : e.name;
}
const $e = 1e3;
function tn() {
  return un() + "/api3/graphql";
}
function on(e) {
  let n;
  return String(e).match(/^\d+$/) ? n = Number(e) : n = String(e), n;
}
const Y = new rl(tn(), {
  headers: {
    authorization: `Bearer ${ee.getAccessToken()}`
  }
});
function ke(e) {
  Y.setHeader("authorization", `Bearer ${e}`), Y.setEndpoint(tn());
}
function Ll(e) {
  return e.replace(/\[\d+\]/g, "[]");
}
async function ue(e, n, l = [], i) {
  var I, A, m, C;
  l = l.map(Ll);
  const a = M(Ne(e));
  if (!a || a.length === 0)
    throw new Error(`Entity ${e} not found`);
  const t = l.length > 0 ? a.filter((T) => l.includes(T.fullName)) : a;
  (I = n.filters) == null || I.forEach((T) => {
    if (!(T != null && T.field))
      throw new Error("Field is required");
    if (!t.find((D) => D.fullName === T.field))
      throw new Error(`Field ${String(T.field)} not found in entity ${e}`);
  }), (A = n.orderBy) == null || A.forEach((T) => {
    if (!t.find((D) => D.fullName === T.field))
      throw new Error(`Field ${String(T.field)} not found in entity ${e}`);
  });
  const s = {};
  (m = n.filters) == null || m.forEach((T) => {
    if (!(T != null && T.field))
      throw new Error("Field is required");
    const _ = T.field, D = `{operation: ${T.operation}, value: ${T.value}, mode: ${T.mode || "AND"}}`;
    s[_] || (s[_] = { operations: [], result: "" }), s[_].operations.push(D);
  }, {}), Object.entries(s).forEach(([, T]) => {
    T.result = `@filters(items: [${T.operations.join(", ")}])`;
  });
  const p = {};
  (C = n.orderBy) == null || C.forEach((T, _) => {
    const D = `@orderBy(direction: ${T.direction}, index: ${_})`;
    p[T.field] || (p[T.field] = []), p[T.field].push(D);
  });
  const r = (i == null ? void 0 : i.queryName) || Le(e);
  function N() {
    const T = {};
    t.forEach((B) => {
      const b = B.fullName.split(".");
      let J = T;
      b.forEach((x, F) => {
        var ne, le;
        x = x.replace(/\[\]/g, ""), F === b.length - 1 ? J[x] = `${B.name} ${((ne = s[B.fullName]) == null ? void 0 : ne.result) || ""} ${((le = p[B.fullName]) == null ? void 0 : le.join(" ")) || ""}`.trim() : (J[x] || (J[x] = {}), J = J[x]);
      });
    });
    function _(B) {
      let b = `{
`;
      for (const J in B)
        typeof B[J] == "object" && !Array.isArray(B[J]) ? b += `${J} ${_(B[J])}
` : b += `${String(B[J])}
`;
      return b + "}";
    }
    const D = Object.keys(T)[0];
    return _(T[D]);
  }
  const f = i != null && i.additionalInputParams ? ", input: { " + Object.entries(i.additionalInputParams).map(([T, _]) => {
    const D = typeof _ == "string" ? '"' : "";
    return `${T}: ${D}${_}${D}`;
  }).join(" ") + "}" : "", R = `
    query ${e}($page: Int!, $limit: Int!) {
      ${r}(page: $page, limit: $limit ${f}) {
        list
          ${N()}
        paginationInfo {
          limit
          page
          total
        }
      }
    }
  `;
  return ke(ee.getAccessToken()), (await Y.request(Te`${R}`, {
    page: n.page || 0,
    limit: n.limit || 10,
    ...(i == null ? void 0 : i.additionalInputParams) || {}
  }))[r];
}
async function kl(e, n) {
  const l = `Create${e}`, i = `create${e}`, a = M(Ne(e));
  if (!a)
    throw new Error(`Entity ${e} not found`);
  const t = a.filter((r) => r.fullName.split(".").length <= 2), s = `
    mutation ${l}($input: ${ln(e)}!) {
      ${i}(input: $input) {
        ${t.map((r) => r.name).join(`
`)}
      }
    }
  `;
  return ke(ee.getAccessToken()), (await Y.request(Te`${s}`, { input: n }))[i];
}
async function Al(e, n, l) {
  const i = `Update${e}`, a = `update${e}`, t = Tl(e);
  if (!t)
    throw new Error(`Entity ${e} not found`);
  const s = t.filter((f) => f.fullName.split(".").length <= 2);
  l = on(l);
  const p = typeof l == "number" ? "Int" : "String", r = `
    mutation ${i}($input: ${an(e)}!, $id: ${p}!) {
      ${a}(input: $input, id: $id) {
        ${s.map((f) => f.name).join(`
`)}
      }
    }`;
  return ke(ee.getAccessToken()), (await Y.request(Te`${r}`, { input: n, id: l }))[a];
}
async function Rl(e, n) {
  const l = `Delete${e}`, i = `delete${e}`, a = `
    mutation ${l}($id: Int!) {
      ${i}(id: $id) {
        success
      }
    }`;
  return ke(ee.getAccessToken()), (await Y.request(Te`${a}`, { id: n }))[i];
}
function Bl(e, n = []) {
  const l = Le(e), i = Je([]), a = Je(0);
  let t = {};
  const s = M(Ne(e));
  if (!s || s.length === 0)
    throw new Error(`Entity ${e} not found`);
  function p(m) {
    t = { ...t, ...m };
  }
  async function r(m) {
    return await kl(e, m);
  }
  async function N(m, C) {
    const T = Object.fromEntries(Object.entries(m).filter(([, D]) => D !== void 0));
    return await Al(e, T, C);
  }
  async function f(m) {
    return await Rl(e, m);
  }
  async function R(m) {
    const C = await ue(e, m, n, t);
    if (!(C != null && C.list))
      throw new Error(`No data returned for ${e}`);
    return i.value = be(C.list), a.value = C.paginationInfo.total, { total: C.paginationInfo.total, items: i };
  }
  async function L(m, C) {
    const T = {
      page: 0,
      limit: $e,
      filters: C !== void 0 ? [
        {
          field: `${l}.${m}`,
          operation: X.Eq,
          value: on(C)
        }
      ] : void 0
    }, _ = await ue(e, T, n, t);
    if (_ != null && _.list)
      return i.value = be(_.list), a.value = _.paginationInfo.total, { total: _.paginationInfo.total, items: i };
  }
  async function I(m) {
    const C = {
      page: 0,
      limit: 1,
      filters: [
        {
          field: `${l}.id`,
          operation: X.Eq,
          value: m
        }
      ]
    }, T = await ue(e, C, n, t);
    if (T != null && T.list)
      return T.list[0];
  }
  async function A(m, C) {
    const T = {
      page: 0,
      limit: $e,
      filters: C !== void 0 ? [
        {
          field: `${l}.${m}`,
          operation: X.Eq,
          value: C
        }
      ] : void 0
    }, _ = await ue(e, T, n, t);
    if (_ != null && _.list)
      return _.list;
  }
  return {
    items: i,
    total: a,
    shortName: l,
    query: R,
    queryByField: L,
    create: r,
    update: N,
    remove: f,
    fetchOne: I,
    fetchMany: A,
    setQueryOverrides: p
  };
}
export {
  Ol as FILTER_RULES,
  dn as FilterModeTypeDefinition,
  X as FilterOperationsTypeDefinition,
  Y as GQLClient,
  Il as GQL_QUERY_TYPE_WRAPPERS,
  kl as GqlCreateMutation,
  Rl as GqlDeleteMutation,
  ue as GqlPaginatedQuery,
  Al as GqlUpdateMutation,
  c as OP,
  rn as OrderByDirectionDefinition,
  cn as Pos2VolumePropertyTypes,
  w as array,
  ln as entityCreateGqlInputName,
  hl as entityFileName,
  Ne as entityFullGqlName,
  an as entityUpdateGqlInputName,
  Dl as filterInputFields,
  Sl as getCreateInputFields,
  Pl as getI18nTitle,
  Tl as getQueryInputFields,
  _l as getSchema,
  M as getTypeFields,
  Ul as getUpdateInputFields,
  Te as gql,
  te as like,
  Be as localEntityName,
  El as localPrettyName,
  ie as quoteArray,
  ce as quotes,
  Le as shortLocalEntityName,
  Nl as toKebap,
  ke as updateToken,
  Bl as usePaginatedEntity
};
